{
  "rti": {
    "preferredAccess": {
      "inspectInPerson": "තැනැත්තා විසින්ම ලේඛන/වාර්තා පරීක්ෂා කිරීම",
      "receiveCopies": "ලේඛන හෝ වාර්තාවල පිටපත් ලබා ගැනීම",
      "certifiedSamples": "ද්‍රව්‍යයේ සහතික කළ සාම්පල ලබා ගැනීම",
      "digitalOrPrinted": "ඩිජිටල් හෝ මුද්‍රිත ආකෘතියෙන් ලබා ගැනීම"
    }
  },
  "common": {
    "cancel": "අවලංගු කරන්න",
    "save": "සුරකින්න",
    "logout": "ඉවත් වන්න",
    "logoutConfirm": "ඔබට නිසැකවම ඉවත් වීමට අවශ්‍යද?",
    "active": "සක්‍රිය",
    "inactive": "අක්‍රිය",
    "close": "වසන්න",
    "confirm": "තහවුරු කරන්න",
    "delete": "මකන්න",
    "loading": "පූරණය වෙමින්…",
    "checking": "පරීක්ෂා කරමින්…",
    "saving": "සුරකිමින්…",
    "deleting": "මකමින්…",
    "yes": "ඔව්",
    "no": "නැත",
    "settingsMenu": "සැකසුම් මෙනුව",
    "reset": "නැවත සකසන්න",
    "search": "සොයන්න",
    "previous": "පෙර",
    "next": "ඊළඟ",
    "first": "පළමු",
    "last": "අවසාන",
    "noDataFound": "දත්ත නොමැත",
    "noResultsFound": "ප්‍රතිඵල නොමැත",
    "typeAtLeastLetters": "අවම වශයෙන් අකුරු {{count}}ක් ටයිප් කරන්න",
    "entries": "වාර්තා",
    "showingEntries": "{{total}} න් {{from}} සිට {{to}} දක්වා පෙන්වයි",
    "actions": "ක්‍රියා",
    "status": "තත්ත්වය",
    "back": "ආපසු",
    "print": "මුද්‍රණය",
    "edit": "සංස්කරණය",
    "view": "බලන්න",
    "supervisor": "අධීක්ෂක",
    "selectUser": "පරිශීලකයා තෝරන්න",
    "selectSupervisor": "අධීක්ෂක තෝරන්න",
    "failedToLoad": "පූරණය කළ නොහැක",
    "draft": "කෙටුම්පත",
    "to": "වෙත",
    "rowsPerPage": "පිටුවක පේළි:",
    "selectedCount": "{{count}} තෝරා ඇත",
    "signIn": "පිවිසෙන්න",
    "noUsersFound": "පරිශීලකයින් හමු නොවීය",
    "noOptionsFound": "විකල්ප හමු නොවීය",
    "noStagesFound": "අදියර හමු නොවීය",
    "noFilesUploaded": "ගොනු උඩුගත කර නැත.",
    "noDocumentsDeclared": "ලේඛන ප්‍රකාශ කර නැත.",
    "noSubsidiaryTasksAssigned": "අතුරු කාර්යයන් පවරා නැත.",
    "noPreviousAdviceDocuments": "පෙර උපදේශන ලේඛන උඩුගත කර නැත."
  },
  "languages": {
    "english": "English",
    "sinhala": "සිංහල",
    "tamil": "தமிழ்"
  },
  "validation": {
    "fieldRequired": "{{field}} අවශ්‍ය වේ.",
    "maxCharLimit": "උපරිම අක්ෂර සීමාව ඉක්මවා ඇත.",
    "dateFutureOnly": "වත්මන් සහ අනාගත දිනයන් පමණක් අවසර දෙනු ලැබේ.",
    "docReasonRequired": "අනිවාර්ය ලේඛනයක් උඩුගත නොකළ විට හේතුව අවශ්‍ය වේ.",
    "contactNumberDigitsOnly": "දුරකථන අංකයේ අංක පමණක් අඩංගු විය යුතුය.",
    "contactNumberExactLength": "දුරකථන අංකය අංක {{count}} ක් විය යුතුය.",
    "contactNumberMustStartWithZero": "දුරකථන අංකය 0 න් ආරම්භ විය යුතුය.",
    "validContactNumber": "වලංගු දුරකථන අංකයක් ඇතුළත් කරන්න.",
    "dateOfOffenceFuture": "වරද සිදු වූ දිනය අනාගතයේ විය නොහැක.",
    "addAtLeastOnePublicCorporationName": "අවම වශයෙන් එක් පොදු නිවේශිත සංස්ථාවක නමක් එකතු කරන්න."
  },
  "header": {
    "systemName": "නඩු කළමනාකරණ පද්ධතිය – AGD",
    "intranetPortal": "අභ්‍යන්තර ද්වාරය",
    "notifications": "දැනුම්දීම්",
    "userProfile": "පරිශීලක පැතිකඩ",
    "settings": "සැකසුම්",
    "info": "නඩු අවස්ථා",
    "accountMenu": "ගිණුම් මෙනුව",
    "profile": "පැතිකඩ",
    "switchRole": "භූමිකාව මාරු කරන්න",
    "selectUserRole": "පරිශීලක භූමිකාව තෝරන්න",
    "switch": "මාරු කරන්න",
    "signOut": "ඉවත් වන්න",
    "noRolesAvailable": "භූමිකා නොමැත",
    "switchRoleFailed": "භූමිකාව මාරු කළ නොහැකි විය. නැවත උත්සාහ කරන්න."
  },
  "settings": {
    "theme": "තේමාව",
    "mode": "මාදිලිය",
    "light": "ආලෝකය",
    "dark": "අඳුරු",
    "primary": "ප්‍රාථමික",
    "primaryColor": "ප්‍රාථමික වර්ණය",
    "resetTheme": "තේමාව නැවත සකසන්න",
    "language": "භාෂාව"
  },
  "nav": {
    "expandNavigation": "සංචාලනය පුළුල් කරන්න",
    "collapseNavigation": "සංචාලනය සංකෝචනය කරන්න",
    "mainNavigation": "ප්‍රධාන සංචාලනය",
    "groups": {
      "dashboard": "උපකරණ පුවරුව",
      "work": "කටයුතු",
      "operations": "මෙහෙයුම්",
      "legalKnowledgeArchiveManagement": "නීතිමය දැනුම සංරක්ෂණ කළමනාකරණය",
      "legalKnowledgeArchive": "නීතිමය දැනුම සංරක්ෂණය",
      "auditLogs": "විගණන ලොග",
      "administration": "පරිශීලක පරිපාලනය",
      "workflowManagement": "වැඩ පිළිවෙල කළමනාකරණය",
      "reports": "වාර්තා",
      "metadata": "Metadata"
    },
    "tasksAndCases": "කාර්ය සහ නඩු",
    "caseDetails": "නඩු විස්තර",
    "attendingTasksAndCases": "නඩු විස්තර",
    "assignTasks": "කාර්ය පවරන්න",
    "escalationTasks": "උසස් කිරීමේ කාර්ය",
    "sgDashboard": "SG උපකරණ පුවරුව",
    "operationalDashboard": "මෙහෙයුම්",
    "caseRequests": "නඩු ඉල්ලීම්",
    "mailRoom": "නඩු ඉදිරිපත් කිරීමේ ඉල්ලීම්",
    "recordRoom": "සම්පූර්ණ කළ ගොනු",
    "qrScanningLog": "QR ස්කෑනिंग ලොගය",
    "legalKnowledge": "නීතිමය දැනුම සංරක්ෂණය",
    "extractedCaseOutcomes": "උපුටා ගත් නඩු ප්‍රතිඵල",
    "dashboard": "උපකරණ පුවරුව",
    "allIntranetUsers": "අභ්‍යන්තර පරිශීලකයින්",
    "userCategories": "පරිශීලක කාණ්ඩ",
    "allExtranetUsers": "බාහිර පරිශීලකයින්",
    "rolesPermissions": "පරිශීලක භූමිකා සහ අවසර",
    "dashboards": "උපකරණ පුවරු",
    "auditLogs": "විගණන ලොග",
    "userPerformanceReport": "පරිශීලක කාර්ය සාධන වාර්තාව",
    "caseTrackingReport": "නඩු නිරීක්ෂණ වාර්තාව",
    "workflowPerformanceReport": "වැඩ පිළිවෙල කාර්ය සාධන වාර්තාව",
    "workflowTemplates": "වැඩ පිළිවෙල අච්චු",
    "kpiConfiguration": "KPI වින්‍යාසය",
    "escalationRules": "උසස් කිරීමේ නීති",
    "subcategory": "උප ගොනු කාණ්ඩ",
    "court": "අධිකරණ නාම",
    "language": "භාෂා වර්ග",
    "country": "රටවල්",
    "nationality": "ජාතිකත්වයන්",
    "policeStation": "පොලිස් ස්ථාන",
    "letterTemplates": "ලිපි අච්චු",
    "subsidiaryTasks": "උප කාර්යයන්",
    "caseScenarios": "නඩු අවස්ථා"
  },
  "profile": {
    "breadcrumb": "පරිශීලක පැතිකඩ",
    "title": "පරිශීලක පැතිකඩ",
    "upload": "උඩුගත කරන්න",
    "delete": "මකන්න",
    "name": "නම",
    "emailUsername": "ඊ-තැපෑල/පරිශීලක නාමය",
    "emailHint": "මෙම ඊ-තැපෑල ලිපිනය පරිශීලක නාමය ලෙස භාවිත කරනු ඇත.",
    "userRole": "පරිශීලක භූමිකාව",
    "userRoles": "පරිශීලක භූමිකා(ය)",
    "divisionUnit": "අංශය / ඒකකය",
    "nicPassport": "ජා. හැඳුනුම්පත් / ගමන් බලපත් අංකය",
    "designation": "තනතුර",
    "serviceId": "සේවා අංකය",
    "contactNumber": "දුරකථන අංකය",
    "contactPlaceholder": "උදා: 07X XXX XXXX",
    "systemInformation": "පද්ධති තොරතුරු",
    "createdAt": "සාදන ලද දිනය/වේලාව",
    "createdBy": "සාදන ලද්දේ",
    "lastUpdatedAt": "අවසන් යාවත්කාලීන කළ දිනය/වේලාව",
    "lastUpdatedBy": "අවසන් යාවත්කාලීන කළේ",
    "loadingProfile": "පැතිකඩ පූරණය වෙමින්…",
    "loadFailed": "පැතිකඩ පූරණය කළ නොහැකි විය.",
    "saveSuccess": "පැතිකඩ සාර්ථකව යාවත්කාලීන කරන ලදී.",
    "saveFailed": "පැතිකඩ සුරැකිය නොහැක.",
    "uploadFailed": "පැතිකඩ රූපය උඩුගත කළ නොහැක.",
    "invalidImage": "කරුණාකර වලංගු රූප ගොනුවක් (JPEG, PNG, හෝ WebP) තෝරන්න.",
    "imageTooLarge": "රූපය MB 2 ක් හෝ ඊට අඩු විය යුතුය.",
    "profileImageAlt": "පැතිකඩ ඡායාරූපය",
    "deletePhotoTitle": "පැතිකඩ ඡායාරූපය ඉවත් කරන්න",
    "uploading": "උඩුගත වෙමින්…",
    "uploadImage": "රූපය උඩුගත කරන්න",
    "maxCharLimit": "උපරිම අක්ෂර සීමාව ඉක්මවා ඇත.",
    "invalidNicPassport": "වලංගු ජා. හැඳුනුම්පත් හෝ ගමන් බලපත් අංකයක් ඇතුළත් කරන්න."
  },
  "confirmDelete": {
    "title": "මකා දැමීම තහවුරු කරන්න",
    "message": "ඔබට මෙම අයිතමය මකා දැමීමට අවශ්‍ය බව විශ්වාසද? මෙම ක්‍රියාව අහෝසි කළ නොහැක.",
    "messageWithEntity": "{{entityLabel}} \"{{entityName}}\" මකන්නද?"
  },
  "legalKnowledge": {
    "status": {
      "draft": "කෙටුම්පත",
      "published": "ප්‍රකාශිත",
      "rejected": "ප්‍රතික්ෂේපිත"
    },
    "archive": {
      "breadcrumb": "නීතිමය දැනුම සංරක්ෂණය",
      "title": "නීතිමය දැනුම සංරක්ෂණය",
      "subtitle": "ප්‍රකාශිත නීතිමය දැනුම සංරක්ෂණ වාර්තා සොයන්න සහ බලන්න.",
      "tableTitle": "නීතිමය දැනුම සංරක්ෂණ විස්තර",
      "colPublishedAt": "ප්‍රකාශිත දිනය",
      "publishedFrom": "ප්‍රකාශිත දිනය සිට",
      "viewArchivedCaseDetailsTip": "සංරක්ෂණය කළ නඩු විස්තර බලන්න",
      "tabsAriaLabel": "නීතිමය දැනුම කොටස්",
      "tabOutcomes": "උපුටා ගත් ප්‍රතිඵල",
      "tabSearch": "සංරක්ෂණය සොයන්න",
      "tabLinkages": "නඩු සම්බන්ධතා",
      "tabDashboard": "උපකරණ පුවරුව",
      "outcomesTableTitle": "උපුටා ගත් නඩු ප්‍රතිඵල ලැයිස්තුව බලන්න",
      "outcomesLegend": "කෙටුම්පත් / ප්‍රකාශිත / ප්‍රතික්ෂේපිත වාර්තා (FR55)",
      "colCaseRef": "නඩු / ඉල්ලීම් යොමුව",
      "colCaseType": "නඩු වර්ගය",
      "colOutcomeTitle": "ප්‍රතිඵල මාතෘකාව",
      "colPublicationStatus": "ප්‍රකාශන තත්ත්වය",
      "colExtractedAt": "උපුටා ගත් දිනය",
      "colRef": "යොමුව",
      "colSummary": "සාරාංශය",
      "colFromRef": "ආරම්භක යොමුව",
      "colToRef": "අවසන් යොමුව",
      "colLinkType": "සම්බන්ධතා වර්ගය",
      "colNotes": "සටහන්",
      "viewDetailsTip": "විස්තර බලන්න",
      "reviewDraftTip": "කෙටුම්පත සමාලෝචනය කරන්න",
      "open": "විවෘත කරන්න",
      "metadataSearch": "පාරදත්ත සෙවීම",
      "metadataSearchPlaceholder": "යොමුව, නඩු වර්ගය, මාතෘකාව, යතුරු වචන…",
      "fullTextSearch": "සම්පූර්ණ-පෙළ සෙවීම",
      "fullTextSearchPlaceholder": "සාරාංශයේ හෝ සම්පූර්ණ කථාවේ වචන…",
      "clear": "මකන්න",
      "searchResultsTitle": "සෙවුම් ප්‍රතිඵල",
      "linkagesTableTitle": "අදාළ නඩු සම්බන්ධතා (FR59)",
      "addLinkage": "සම්බන්ධතාව එක් කරන්න",
      "analyticsSummary": "සාරාංශය (FR60)",
      "totalRecords": "මුළු වාර්තා",
      "drafts": "කෙටුම්පත්",
      "recordsByCaseType": "නඩු වර්ගය අනුව වාර්තා",
      "archivedCaseDetails": "සංරක්ෂණය කළ නඩු විස්තර",
      "reference": "යොමුව",
      "fullNarrative": "සම්පූර්ණ කථාව",
      "relatedSimilarCases": "අදාළ / සමාන නඩු (FR58)",
      "noLinkedReferences": "මෙම වාර්තාවේ සම්බන්ධිත යොමු නොමැත.",
      "reviewDraftTitle": "නඩු ප්‍රතිඵල කෙටුම්පත සමාලෝචනය (FR56)",
      "outcomeText": "ප්‍රතිඵල පෙළ",
      "approvePublish": "අනුමත කර ප්‍රකාශ කරන්න",
      "retainDraft": "කෙටුම්පත තබා ගන්න",
      "reject": "ප්‍රතික්ෂේප කරන්න",
      "addCaseLinkage": "නඩු සම්බන්ධතාව එක් කරන්න",
      "fromReference": "ආරම්භක යොමුව",
      "toReference": "අවසන් යොමුව",
      "selectPlaceholder": "තෝරන්න…",
      "linkTypeRelatedPrecedent": "අදාළ පූර්වාදර්ශය",
      "linkTypeSimilarSubject": "සමාන විෂය කරුණ",
      "linkTypeFollowOn": "අනුගාමී කරුණ",
      "chooseDifferentRefs": "කරුණාකර වෙනස් යොමු අංක දෙක තෝරන්න.",
      "linkageSavedMock": "සම්බන්ධතාව සුරකින ලදී (ආදර්ශ).",
      "outcomePublishedMock": "ප්‍රතිඵල අනුමත කර ප්‍රකාශ කරන ලදී (ආදර්ශ).",
      "draftRetained": "කෙටුම්පත තබා ගන්නා ලදී.",
      "draftRejectedMock": "කෙටුම්පත ප්‍රතික්ෂේප කරන ලදී (ආදර්ශ)."
    },
    "outcomes": {
      "title": "උපුටා ගත් නඩු ප්‍රතිඵල",
      "tableTitle": "උපුටා ගත් නඩු ප්‍රතිඵල විස්තර",
      "footerCountNoun": "ප්‍රතිඵල",
      "colArchiveRefNo": "සංරක්ෂණ යොමු අංකය",
      "colFileRefNo": "ගොනු යොමු අංකය",
      "colFileCategory": "ගොනු කාණ්ඩය",
      "colSubFileCategory": "උප ගොනු කාණ්ඩය",
      "colOutcomeExtractedAt": "ප්‍රතිඵල උපුටා ගත් දිනය",
      "colCaseCompletedAt": "නඩුව සම්පූර්ණ කළ දිනය",
      "editTip": "කෙටුම්පත සංස්කරණය",
      "editDraftTip": "කෙටුම්පත සංස්කරණය",
      "viewArchivedTip": "සංරක්ෂණය කළ නඩු විස්තර බලන්න",
      "viewTip": "සංරක්ෂණය කළ නඩු විස්තර බලන්න",
      "archiveReferenceNumber": "සංරක්ෂණ යොමු අංකය",
      "archiveReferenceNumberPlaceholder": "සංරක්ෂණ යොමු අංකය ඇතුළත් කරන්න",
      "fileReferenceNumber": "ගොනු යොමු අංකය",
      "fileReferenceNumberPlaceholder": "ගොනු යොමු අංකය ඇතුළත් කරන්න",
      "fileCategories": "ගොනු කාණ්ඩ(ය)",
      "fileCategoriesPlaceholder": "ගොනු කාණ්ඩ(ය) තෝරන්න",
      "subFileCategories": "උප ගොනු කාණ්ඩ(ය)",
      "subFileCategoriesPlaceholder": "උප ගොනු කාණ්ඩ(ය) තෝරන්න",
      "statuses": "තත්ත්ව(ය)",
      "statusesPlaceholder": "තත්ත්ව(ය) තෝරන්න",
      "enterText": "පෙළ ඇතුළත් කරන්න",
      "enterTextPlaceholder": "පෙළ හෝ වාක්‍ය ඛණ්ඩය ඇතුළත් කරන්න",
      "caseCompletedFrom": "නඩුව සම්පූර්ණ කළ දිනය සිට",
      "outcomeExtractedFrom": "ප්‍රතිඵල උපුටා ගත් දිනය සිට"
    },
    "categories": {
      "criminal": "අපරාධ",
      "civilDivisionAdvise": "සිවිල් අංශය - උපදෙස්",
      "civilDivisionLitigation": "සිවිල් අංශය - නඩු",
      "civilAppellateDivision": "සිවිල් අභියෝග අංශය",
      "criminalAppellateDivision": "අපරාධ අභියෝග අංශය",
      "extraditionMla": "ප්‍රත්‍යර්පණය සහ MLA",
      "rightToInformation": "තොරතුරු දැනගැනීමේ අයිතිය",
      "publicPetitions": "පොදු පෙත්සම්",
      "nominationRequests": "නම් කිරීමේ ඉල්ලීම්",
      "attorneyGeneralInternal": "Attorney General | AGD-Internal"
    },
    "subCategories": {
      "offenceHumanBody": "Offence Affecting Human Body/Life",
      "offenceProperty": "Offence against Property",
      "generalLegalAdvice": "E - General Legal Advice",
      "draftingAgreements": "E - Drafting of Agreements",
      "originalCourt": "OC - Original Court",
      "writPetition": "WP - Writ Petition",
      "mutualLegalAssistance": "MLA - Mutual Legal Assistance",
      "extradition": "EXT - Extradition",
      "courtOfAppeal": "COA - Court of Appeal",
      "supremeCourt": "SC - Supreme Court",
      "highCourtAppeals": "HC - High Court Appeals",
      "supremeCourtAppeals": "SC - Supreme Court Appeals",
      "rtiGeneral": "RTI - General",
      "ppCriminalMatter": "PP - Criminal Matter",
      "ppCivilMatter": "PP - Civil Matter"
    },
    "dashboardPage": {
      "title": "උපකරණ පුවරුව",
      "totalPublished": "මුළු ප්‍රකාශිත",
      "totalPublishedDesc": "නීතිමය දැනුම සංරක්ෂණයට ප්‍රකාශිත වාර්තා ගණන",
      "draftsDesc": "කෙටුම්පත් තත්ත්වයේ උපුටා ගත් නඩු ප්‍රතිඵල ගණන",
      "rejectedDesc": "සමාලෝචනයෙන් පසු ප්‍රතික්ෂේපිත උපුටා ගත් නඩු ප්‍රතිඵල ගණන",
      "today": "අද ({{date}})",
      "byCategoryTitle": "ගොනු කාණ්ඩය සහ උප ගොනු කාණ්ඩය අනුව ප්‍රකාශිත වාර්තා",
      "byCategoryDesc": "නීතිමය දැනුම සංරක්ෂණයට ප්‍රකාශිත සියලු වාර්තා ගොනු කාණ්ඩය සහ උප ගොනු කාණ්ඩය අනුව",
      "byPeriodTitle": "කාල සීමාව අනුව ප්‍රකාශිත වාර්තා",
      "byPeriodDesc": "නීතිමය දැනුම සංරක්ෂණයට ප්‍රකාශිත සියලු වාර්තා කාල සීමාව අනුව",
      "loading": "පූරණය වෙමින්…",
      "loadFailed": "උපකරණ පුවරු දත්ත පූරණය කිරීමට අසමත් විය.",
      "drafts": "කෙටුම්පත්",
      "rejected": "ප්‍රතික්ෂේපිත"
    },
    "viewOutcome": {
      "draftBreadcrumb": "උපුටා ගත් නඩු ප්‍රතිඵල කෙටුම්පත",
      "draftTitle": "උපුටා ගත් නඩු ප්‍රතිඵල කෙටුම්පත",
      "recordNotFound": "වාර්තාව හමු නොවීය.",
      "backToList": "ලැයිස්තුවට ආපසු",
      "retainAsDraft": "කෙටුම්පත ලෙස තබා ගන්න",
      "edit": "සංස්කරණය",
      "approveAndPublish": "අනුමත කර ප්‍රකාශ කරන්න",
      "backToListBtn": "ලැයිස්තුවට ආපසු",
      "caseOverview": "නඩු දළ විශ්ලේෂණය",
      "archiveReferenceNumber": "සංරක්ෂණ යොමු අංකය",
      "fileReferenceNumber": "ගොනු යොමු අංකය",
      "caseCompletedAt": "නඩුව සම්පූර්ණ කළ දිනය",
      "outcomeExtractedAt": "ප්‍රතිඵල උපුටා ගත් දිනය",
      "fileCategory": "ගොනු කාණ්ඩය",
      "subFileCategory": "උප ගොනු කාණ්ඩය",
      "applicableAreas": "අදාළ ප්‍රදේශ(ය)",
      "requestSubmittedAt": "ඉල්ලීම ඉදිරිපත් කළ දිනය",
      "submittedAgency": "ඉදිරිපත් කළ නියෝජිත ආයතනය",
      "divisionName": "අංශ නාමය",
      "province": "පළාත",
      "district": "දිස්ත්‍රික්කය",
      "caseNumber": "නඩු අංකය",
      "otherExternalRefNos": "වෙනත් බාහිර යොමු අංක",
      "connectedAgdFileRefNo": "සම්බන්ධ AGD ගොනු යොමු අංකය",
      "description": "විස්තරය",
      "courtDetails": "අධිකරණ විස්තර",
      "courtType": "අධිකරණ වර්ගය",
      "courtName": "අධිකරණ නම",
      "incidentMatterDetails": "සිද්ධිය / කාරණය විස්තර",
      "subjectOfDispute": "විවාදයේ විෂය",
      "incidentOccurredDate": "සිද්ධිය සිදු වූ දිනය",
      "applicableStatutes": "අදාළ නීති(ය)",
      "statutesPlaceholder": "අදාළ පනත්, ආඥාපනත් හෝ වෙනත් නීතිමය විධිවිධාන",
      "notProvided": "සපයා නොමැත",
      "extractedOutcomeSummary": "උපුටා ගත් ප්‍රතිඵල සාරාංශය",
      "summaryPlaceholder": "සම්පූර්ණ කළ මෙම නඩුවේ උපුටා ගත් ප්‍රතිඵල සාරාංශය",
      "rejectedReason": "ප්‍රතික්ෂේප කිරීමේ හේතුව",
      "caseLinkages": "නඩු සම්බන්ධතා",
      "addLinkage": "+ සම්බන්ධතාව එක් කරන්න",
      "noCaseLinkages": "නඩු සම්බන්ධතා එක් කර නොමැත.",
      "editLinkageTip": "සම්බන්ධතාව සංස්කරණය",
      "removeLinkageTip": "සම්බන්ධතාව ඉවත් කරන්න",
      "lastUpdatedAt": "අවසන් යාවත්කාලීන කළ දිනය",
      "lastUpdatedBy": "අවසන් යාවත්කාලීන කළේ",
      "rejectModalTitle": "උපුටා ගත් නඩු ප්‍රතිඵල කෙටුම්පත ප්‍රතික්ෂේප කරන්න",
      "rejectReason": "ප්‍රතික්ෂේප හේතුව",
      "rejectReasonPlaceholder": "ප්‍රතික්ෂේප හේතුව ඇතුළත් කරන්න..",
      "rejectReasonRequired": "ප්‍රතික්ෂේප හේතුව අවශ්‍යය.",
      "editCaseLinkage": "නඩු සම්බන්ධතාව සංස්කරණය",
      "addNewCaseLinkage": "නව නඩු සම්බන්ධතාව එක් කරන්න",
      "linkToArchivedCase": "සංරක්ෂණය කළ නඩුවට සම්බන්ධ කරන්න",
      "linkToArchivedCasePlaceholder": "සම්බන්ධිත සංරක්ෂණය කළ නඩුවේ සංරක්ෂණ යොමු අංකය තෝරන්න",
      "statutesRequired": "අදාළ නීති(ය) අවශ්‍යය.",
      "summaryRequired": "උපුටා ගත් ප්‍රතිඵල සාරාංශය අවශ්‍යය.",
      "draftRetainedSuccess": "උපුටා ගත් නඩු ප්‍රතිඵල කෙටුම්පත ලෙස තබා ගන්නා ලදී.",
      "saveFailed": "උපුටා ගත් නඩු ප්‍රතිඵල සුරැකීම අසාර්ථක විය.",
      "publishSuccess": "උපුටා ගත් නඩු ප්‍රතිඵල අනුමත කර ප්‍රකාශ කරන ලදී.",
      "publishFailed": "උපුටා ගත් නඩු ප්‍රතිඵල ප්‍රකාශ කිරීම අසාර්ථක විය.",
      "rejectSuccess": "උපුටා ගත් නඩු ප්‍රතිඵල ප්‍රතික්ෂේප කරන ලදී.",
      "rejectFailed": "උපුටා ගත් නඩු ප්‍රතිඵල ප්‍රතික්ෂේප කිරීම අසාර්ථක විය.",
      "linkageSavedSuccess": "නඩු සම්බන්ධතාව සුරකින ලදී.",
      "linkageSaveFailed": "නඩු සම්බන්ධතාව සුරැකීම අසාර්ථක විය.",
      "linkageRemovedSuccess": "නඩු සම්බන්ධතාව ඉවත් කරන ලදී.",
      "linkageRemoveFailed": "නඩු සම්බන්ධතාව ඉවත් කිරීම අසාර්ථක විය.",
      "rejectConfirmTitle": "ප්‍රතික්ෂේප කිරීම තහවුරු කරන්න",
      "rejectConfirmMessage": "මෙම උපුටා ගත් නඩු ප්‍රතිඵල කෙටුම්පත ප්‍රතික්ෂේප කිරීමට අවශ්‍ය බව විශ්වාසද?",
      "cancelConfirmTitle": "අවලංගු කිරීම තහවුරු කරන්න",
      "cancelConfirmMessage": "වෙනස්කම් සුරැකීමෙන් තොරව අවලංගු කිරීමට අවශ්‍ය බව විශ්වාසද?",
      "removeLinkageConfirmTitle": "නඩු සම්බන්ධතාව ඉවත් කරන්න",
      "removeLinkageConfirmMessage": "මෙම නඩු සම්බන්ධතාව ඉවත් කිරීමට අවශ්‍ය බව විශ්වාසද?"
    },
    "viewArchived": {
      "title": "සංරක්ෂණය කළ නඩු විස්තර බලන්න",
      "breadcrumb": "සංරක්ෂණය කළ නඩු විස්තර",
      "back": "ආපසු",
      "backToArchive": "නීතිමය දැනුම සංරක්ෂණයට ආපසු",
      "loadFailed": "සංරක්ෂණය කළ නඩු විස්තර පූරණය කිරීම අසාර්ථක විය.",
      "rejectReasonLabel": "උපුටා ගත් නඩු ප්‍රතිඵල කෙටුම්පත ප්‍රතික්ෂේප හේතුව"
    }
  },
  "viewRequest": {
    "breadcrumbParent": "කාර්ය සහ නඩු",
    "title": "නඩු ඉල්ලීම බලන්න",
    "fileReferenceNumber": "ගොනු යොමු අංකය",
    "fileCategory": "ගොනු කාණ්ඩය",
    "subFileCategory": "උප ගොනු කාණ්ඩය",
    "currentStatus": "වත්මන් තත්ත්වය",
    "tabCaseDetails": "නඩු විස්තර",
    "tabDocuments": "ලේඛන",
    "tabCommunications": "සන්නිවේදන",
    "loadingCaseRequest": "නඩු ඉල්ලීම පූරණය වෙමින්…",
    "loadingQr": "QR පූරණය වෙමින්…",
    "qrAlt": "නඩු ඉල්ලීම සාරාංශ සටහන QR code",
    "qrUnavailable": "QR code නොමැත",
    "qrTip": "AGD වෙත භෞතික ගොනුව භාර දෙන විට සාරාංශ සටහන සමඟ මෙම QR code ඉදිරිපත් කරන්න.",
    "viewCoverNote": "සාරාංශ සටහන බලන්න",
    "preparing": "සූදානම් වෙමින්…",
    "printCoverNote": "සාරාංශ සටහන මුද්‍රණය කරන්න",
    "caseRequestIdMissing": "නඩු ඉල්ලීම් id අස්ථානගත වී ඇත.",
    "loadFailed": "නඩු ඉල්ලීම පූරණය කළ නොහැකි විය.",
    "notFound": "නඩු ඉල්ලීම හමු නොවීය.",
    "coverNotePdfFailed": "සාරාංශ සටහන PDF පූරණය කළ නොහැකි විය.",
    "inProgress": "ප්‍රගතියේ",
    "documentsLoadFailed": "ලේඛන පූරණය කිරීම අසාර්ථක විය.",
    "communicationsLoadFailed": "සන්නිවේදන පූරණය කිරීම අසාර්ථක විය.",
    "loadingDocuments": "ලේඛන පූරණය වෙමින්…",
    "loadingCommunications": "සන්නිවේදන පූරණය වෙමින්…",
    "requestSubmittedAt": "ඉල්ලීම ඉදිරිපත් කළ වේලාව",
    "applicableAreas": "අදාළ ප්‍රදේශ(ය)"
  },
  "caseRequests": {
    "breadcrumb": "නඩු ඉල්ලීම්",
    "title": "නඩු ඉල්ලීම්",
    "subtitle": "ඔබේ ආයතනය විසින් ඉදිරිපත් කරන ලද සියලු ඉල්ලීම්වල තත්ත්වය බලන්න සහ නිරීක්ෂණය කරන්න.",
    "createCaseRequest": "+ නඩු ඉල්ලීමක් සාදන්න",
    "activeTab": "සක්‍රිය නඩු",
    "completedTab": "සම්පූර්ණ කළ නඩු",
    "tableTitle": "නඩු ඉල්ලීමේ විස්තර",
    "newNotificationLegend": "නව දැනුම්දීමක් ලැබී ඇත",
    "deleteTitle": "නඩු ඉල්ලීම මකන්න",
    "deleteMessage": "මකා දැමීමට අවශ්‍යද? මෙම ක්‍රියාව අහෝසි කළ නොහැක.",
    "loadDraftFailed": "කෙටුම්පත පූරණය කළ නොහැක.",
    "deleteDraftFailed": "කෙටුම්පත මකා දැමීම අසාර්ථක විය. නැවත උත්සාහ කරන්න.",
    "deleteDraftSuccess": "කෙටුම්පත සාර්ථකව මකා දමන ලදී.",
    "duplicateFailed": "නඩුව පිටපත් කිරීම අසාර්ථක විය. නැවත උත්සාහ කරන්න.",
    "duplicateSuccess": "නඩුව සාර්ථකව පිටපත් කරන ලදී. නව කෙටුම්පතක් සාදන ලදී.",
    "coverNoteSubmittedOnly": "සාරාංශ සටහන ඉදිරිපත් කළ ඉල්ලීම් සඳහා පමණක් ලබා ගත හැක.",
    "coverNoteLoadFailed": "සාරාංශ සටහන පූරණය කළ නොහැක.",
    "downloading": "බාගත කරමින්",
    "downloadPdf": "PDF ලෙස බාගත කරන්න",
    "viewRequest": "ඉල්ලීම බලන්න",
    "coverNote": "සාරාංශ සටහන",
    "qrNote": "ගොනු ලබා ගැනීම, නිරීක්ෂණය සහ සාරාංශ සටහන සත්‍යාපනය සඳහා QR code.",
    "fileReferenceNumber": "ගොනු යොමු අංකය",
    "requestSubmittedAt": "ඉල්ලීම ඉදිරිපත් කළ වේලාව",
    "submittedAgency": "ඉදිරිපත් කළ ආයතනය",
    "subFileCategoryLabel": "උප ගොනු කාණ්ඩය: {{value}}",
    "summaryTitle": "ඉල්ලීමේ විස්තර සාරාංශය",
    "caseSource": "නඩු මූලාශ්‍රය",
    "connectedRef": "සම්බන්ධ AGD ගොනු යොමු අංකය",
    "accusedName": "චෝදනාකරු/සැකකරු නම",
    "applicableAreas": "අදාළ ප්‍රදේශ(ය)",
    "urgencyLevel": "අත්‍යවශ්‍යතා මට්ටම",
    "deadline": "අවසන් දිනය",
    "urgencyJustification": "අත්‍යවශ්‍යතා සාධාරණීකරණය",
    "documentsDeclared": "ප්‍රකාශ කළ ලේඛන",
    "noCoverNote": "මෙම නඩුව සඳහා සාරාංශ සටහන නොමැත.",
    "removing": "ඉවත් කරමින්",
    "print": "මුද්‍රණය",
    "loadingCoverNote": "සාරාංශ සටහන පූරණය වෙමින්…",
    "coverNoteUnavailable": "සාරාංශ සටහන විස්තර නොමැත.",
    "qrGenerationFailed": "QR ජනනය අසාර්ථක විය",
    "divisionUnit": "අංශය / ඒකකය",
    "statusLabels": {
      "submitted": "ඉදිරිපත් කරන ලදී",
      "draft": "කෙටුම්පත",
      "inProgress": "ප්‍රගතියේ",
      "registered": "ලියාපදිංචි කරන ලදී",
      "review": "සමාලෝචනය",
      "completed": "සම්පූර්ණ",
      "rejected": "ප්‍රතික්ෂේප",
      "notStarted": "ආරම්භ කර නැත"
    }
  },
  "wizard": {
    "createCaseRequest": "නඩු ඉල්ලීමක් සාදන්න",
    "createSubtitle": "නව නඩු ඉල්ලීමක් ඉදිරිපත් කිරීමට පහත පෝරමය පියවරෙන් පියවර සම්පූර්ණ කරන්න.",
    "reviewBeforeSubmission": "ඉදිරිපත් කිරීමට පෙර සමාලෝචනය",
    "reviewTitle": "නඩු ඉල්ලීමේ විස්තර සමාලෝචනය",
    "reviewSubtitle": "AGD වෙත මෙම ඉල්ලීම ඉදිරිපත් කිරීමට පෙර සියලු තොරතුරු සමාලෝචනය කරන්න.",
    "stepBarLabel": "පියවර {{num}}",
    "reviewStepLabel": "පියවර {{num}}",
    "childUnder16": "දරුවා වයස අවුරුදු 16 ට අඩුය",
    "notAvailable": "නොමැත",
    "accusedSuspect": "චෝදනාකරු / සැකකරු {{num}}",
    "confirm": {
      "main": "ඉහත තොරතුරු නිවැරදි බව මම තහවුරු කරමි",
      "hint": "AGD වෙත මෙම ඉල්ලීම ඉදිරිපත් කිරීමට පෙර කරුණාකර තහවුරු කරන්න."
    },
    "nav": {
      "back": "< ආපසු",
      "next": "ඊළඟ >",
      "saveAsDraft": "කෙටුම්පත ලෙස සුරකින්න",
      "reviewBeforeSubmissionBtn": "ඉදිරිපත් කිරීමට පෙර සමාලෝචනය >",
      "submitRequest": "ඉල්ලීම ඉදිරිපත් කරන්න",
      "submitting": "ඉදිරිපත් කරමින්…",
      "cancelCaseRequest": "නඩු ඉල්ලීම අවලංගු කරන්න",
      "cancelConfirm": "ඔබට අවලංගු කිරීමට අවශ්‍ය බව විශ්වාසද? සුරකි නොකළ වෙනස්කම් නැති වනු ඇත.",
      "draftSaved": "නඩු ඉල්ලීම කෙටුම්පත ලෙස සුරකින ලදී.",
      "draftSaveFailed": "කෙටුම්පත සුරැකීම අසාර්ථක විය.",
      "submitSuccess": "නඩු ඉල්ලීම සාර්ථකව ඉදිරිපත් කරන ලදී.",
      "submitFailed": "ඉදිරිපත් කිරීම අසාර්ථක විය.",
      "fillRequiredFields": "මෙම තිරයේ අවශ්‍ය සියලුම ක්ෂේත්‍ර පුරවන්න."
    },
    "sections": {
      "caseCategorization": "නඩු වර්ගීකරණය",
      "caseIntakeDetails": "නඩු ලබාගැනීමේ විස්තර",
      "caseDetails": "නඩු විස්තර",
      "categorization": "වර්ගීකරණය",
      "victimDetails": "පීඩිත විස්තර",
      "offenceDetails": "වරද විස්තර",
      "timeline": "කාලරාමුව",
      "requestSubmitterDetails": "ඉල්ලීම ඉදිරිපත් කරන අයගේ විස්තර",
      "physicalFileDeliveryMethod": "භෞතික ගොනු බෙදාහැරීමේ ක්‍රමය",
      "partyDetails": "පාර්ශ්ව විස්තර",
      "incidentMatterDetails": "සිද්ධිය/ කාරණය විස්තර",
      "requesterDetails": "ඉල්ලුම්කරුගේ විස්තර",
      "informationRequestDetails": "තොරතුරු ඉල්ලීමේ විස්තර",
      "additionalInformation": "අමතර තොරතුරු",
      "petitionerDetails": "පෙත්සම්කරුගේ විස්තර",
      "respondentDetails": "ප්‍රතිවාදියාගේ විස්තර",
      "accusedPersonDetails": "චෝදනාකරු විස්තර",
      "legalExtraditionCaseDetails": "නීති සහ ප්‍රතිදාන/නීති සහයෝගීතා වාර්තා විස්තර",
      "uploadDocuments": "ලේඛන උඩුගත කරන්න",
      "partiesInvolved": "සම්බන්ධිත පාර්ශ්ව",
      "submission": "ඉදිරිපත් කිරීම"
    },
    "placeholders": {
      "selectFileCategory": "ගොනු කාණ්ඩය තෝරන්න",
      "selectSubFileCategory": "උප ගොනු කාණ්ඩය තෝරන්න",
      "selectApplicableAreas": "අදාළ ප්‍රදේශ(ය) තෝරන්න",
      "briefDescriptionOfCase": "නඩුවේ කෙටි විස්තරය",
      "sourceOfCase": "නඩු මූලාශ්‍රය",
      "selectProvince": "පළාත තෝරන්න",
      "selectDistrict": "දිස්ත්‍රික්කය තෝරන්න",
      "selectCountry": "රට තෝරන්න",
      "loadingCountries": "රටවල් පූරණය වෙමින්…",
      "uploadDocument": "ලේඛනය උඩුගත කරන්න",
      "enterAccusedName": "චෝදනාකරුගේ නම ඇතුළත් කරන්න",
      "enterVictimName": "පීඩිතයාගේ නම ඇතුළත් කරන්න",
      "selectNationality": "ජාතිකත්වය තෝරන්න",
      "loadingNationalities": "ජාතිකත්වයන් පූරණය වෙමින්…",
      "selectCountryOfOrigin": "මුල් රට තෝරන්න",
      "selectGender": "ස්ත්‍රී පුරුෂ භාවය තෝරන්න",
      "selectCustodyStatus": "භාරකරණ තත්ත්වය තෝරන්න",
      "loadingCustodyStatuses": "භාරකරණ තත්ත්වයන් පූරණය වෙමින්…",
      "custodialAuthorityHint": "CID හෝ අදාළ නීති අමලාකරණ අධිකාරිය",
      "selectUrgencyLevel": "අත්‍යවශ්‍යතා මට්ටම තෝරන්න",
      "urgencyJustificationReason": "නඩුවට අත්‍යවශ්‍ය අවධානය අවශ්‍ය වන හේතුව",
      "docSkipReason": "හේතුව ඇතුළත් කරන්න (ලේඛනය උඩුගත නොකළහොත් සඳහන් කරන්න)",
      "specifyDeliveryMethod": "බෙදාහැරීමේ ක්‍රමය සඳහන් කරන්න",
      "enterPlaintiffApplicantName": "වෙන්නේකරු / ඉල්ලුම්කරුගේ නම ඇතුළත් කරන්න",
      "enterDefendantRespondentName": "ප්‍රතිවාදියා / ප්‍රතිචෝදිතයාගේ නම ඇතුළත් කරන්න",
      "enterLegalOfficerNameInCharge": "නීති නිලධාරියා/ භාර නිලධාරියාගේ නම ඇතුළත් කරන්න",
      "otherRelatedInstitutionsHint": "කාරණයට සම්බන්ධ වෙනත් ආයතන",
      "enterInstitutionName": "ආයතන නම ඇතුළත් කරන්න",
      "addCorporation": "+ එකතු කරන්න",
      "remove": "ඉවත් කරන්න",
      "contactNumberExample": "07XXXXXXXX",
      "otherRelatedInstitutionsPublicPrivateHint": "කාරණයට සම්බන්ධ වෙනත් පොදු හෝ පෞද්ගලික ආයතන",
      "specifyCourtType": "අධිකරණ වර්ගය සඳහන් කරන්න",
      "enterCourtName": "අධිකරණයේ නම ඇතුළත් කරන්න",
      "nameOfTheCourt": "අධිකරණයේ නම",
      "detailedLegalIssueDescription": "නීතිමය ගැටලුවේ විස්තරය",
      "selectNextStep": "ඊළඟ පියවර තෝරන්න",
      "enterNextStepOther": "නඩුවේ වෙනත් ඊළඟ පියවර ඇතුළත් කරන්න",
      "enterRespondentNames": "ප්‍රතිචෝදිත(ය)ගේ නම(ය) ඇතුළත් කරන්න",
      "enterRespondentAddress": "ප්‍රතිචෝදිත(ය)ගේ ලිපිනය ඇතුළත් කරන්න",
      "enterNumberOfRespondents": "ප්‍රතිචෝදිත(ය)ගේ සංඛ්‍යාව ඇතුළත් කරන්න",
      "enterPetitionerName": "නම ඇතුළත් කරන්න",
      "enterAttorneyName": "නීතිඥ නම ඇතුළත් කරන්න",
      "selectRespondentType": "ප්‍රතිචෝදිත වර්ගය තෝරන්න",
      "enterRequestorName": "ඉල්ලුම්කරුගේ නම ඇතුළත් කරන්න",
      "enterNicOrPassport": "ජා.හැ. හෝ ගමන් බලපත්‍ර අංකය ඇතුළත් කරන්න",
      "enterAddress": "ලිපිනය ඇතුළත් කරන්න",
      "enterEmailAddress": "විද්‍යුත් තැපැල් ලිපිනය ඇතුළත් කරන්න",
      "enterPublicAuthorityName": "පොදු අධිකාරියේ නම ඇතුළත් කරන්න",
      "describeRequestedInformation": "ඉල්ලූ තොරතුරු විස්තර කරන්න",
      "enterTimePeriodIfApplicable": "කාල සීමාව ඇතුළත් කරන්න (අදාළ නම්)",
      "selectPreferredLanguage": "වඩාත් කැමති භාෂාව තෝරන්න",
      "provideJustification": "සාධාරණීකරණය සපයන්න",
      "additionalNotesOptional": "අමතර සටහන් (විකල්ප)",
      "enterPlaceOfOffence": "වරද සිදු වූ ස්ථානය ඇතුළත් කරන්න",
      "enterAccusedSuspectName": "චෝදනාකරු/සැකකරුගේ නම ඇතුළත් කරන්න",
      "selectStatus": "තත්ත්වය තෝරන්න",
      "specifyStatus": "තත්ත්වය සඳහන් කරන්න",
      "enterUrgencyJustification": "අත්‍යවශ්‍යතා සාධාරණීකරණය ඇතුළත් කරන්න",
      "caseSourceOther": "නඩු මූලාශ්‍රය (වෙනත්)",
      "selectMagistrateCourt": "මහේස්ත්‍රාත් අධිකරණය තෝරන්න",
      "selectHighCourt": "අග්‍රාමාත්‍ය අධිකරණය තෝරන්න",
      "selectPoliceStation": "පොලිස් ස්ථානය තෝරන්න",
      "incomingOutgoing": "ලැබෙන / පිටවන",
      "policeMagistrateRef": "පොලිස් / මහේස්ත්‍රාත් යොමු අංකය",
      "commaSeparatedReferences": "කොමාවෙන් වෙන් කළ යොමු",
      "courtReferenceNumber": "අධිකරණ යොමු අංකය",
      "connectedAgdHint": "අදාළ සම්බන්ධ AGD ගොනු යොමු අංකය ඔබ නොදන්නේ නම්, 'තිබේ' කොටුව සලකුණු කරන්න.",
      "briefDescriptionAdviceSought": "කෙටි විස්තරය — ඉල්ලූ උපදෙස්",
      "selectCorporateInstitute": "සංස්ථාගත ආයතනය තෝරන්න",
      "enterOtherInstituteName": "වෙනත් ආයතන නම ඇතුළත් කරන්න",
      "enterExternalReferenceNumber": "බාහිර යොමු අංකය ඇතුළත් කරන්න",
      "commaSeparatedReferenceNumbers": "කොමාවෙන් වෙන් කළ යොමු අංක",
      "includeConnectedCaseDetails": "සම්බන්ධ නඩු විස්තර ඇතුළත් කරන්න",
      "enterConnectedCaseNumber": "සම්බන්ධ නඩු අංකය ඇතුළත් කරන්න",
      "enterConnectedAgdFileRef": "සම්බන්ධ AGD ගොනු යොමු අංකය ඇතුළත් කරන්න"
    },
    "fields": {
      "fileCategory": "ගොනු කාණ්ඩය",
      "subFileCategory": "උප ගොනු කාණ්ඩය",
      "description": "විස්තර",
      "caseSource": "නඩු මූලාශ්‍රය",
      "province": "පළාත",
      "district": "දිස්ත්‍රික්කය",
      "highCourtName": "අග්‍රාමාත්‍ය අධිකරණ නම",
      "magistrateCourtName": "මහේස්ත්‍රාත් අධිකරණ නම",
      "policeStation": "පොලිස් ස්ථානය",
      "yourReferenceNumber": "ඔබේ යොමු අංකය (බාහිර)",
      "otherExternalReferences": "වෙනත් බාහිර යොමු අංක(ය)",
      "caseNumber": "නඩු අංකය",
      "connectedMatters": "සම්බන්ධ කාරණා (නඩු) තිබේද?",
      "connectedMattersShort": "සම්බන්ධ කාරණා",
      "connectedCaseNumber": "සම්බන්ධ නඩු අංකය",
      "connectedAgdFileRef": "සම්බන්ධ AGD ගොනු යොමු අංකය",
      "victimName": "පීඩිතයාගේ නම",
      "dateOfBirth": "උපන් දිනය",
      "age": "වයස",
      "gender": "ස්ත්‍රී පුරුෂ භාවය",
      "dateOfOffence": "වරද සිදු වූ දිනය",
      "placeOfOffence": "වරද සිදු වූ ස්ථානය",
      "accusedDetailsAvailable": "චෝදනාකරු/සැකකරු විස්තර තිබේද",
      "accusedSuspects": "චෝදනාකරු / සැකකරු",
      "urgencyLevel": "අත්‍යවශ්‍යතා මට්ටම",
      "deadline": "අවසාන දිනය",
      "deadlineIfAny": "අවසාන දිනය (ඇත්නම්)",
      "urgencyJustification": "අත්‍යවශ්‍යතා සාධාරණීකරණය",
      "submittedDivisionUnit": "ඉදිරිපත් කළ අංශය/ ඒකකය",
      "submittedDivisionUnitNoSpace": "ඉදිරිපත් කළ අංශය/ඒකකය",
      "submittedAgencyName": "ඉදිරිපත් කළ නියෝජිත ආයතන නම",
      "designation": "තනතුර",
      "submittedBy": "ඉදිරිපත් කළේ",
      "emailAddress": "ඊ-තැපෑල",
      "contactNumber": "දුරකථන අංකය",
      "physicalFileDeliveryMethod": "භෞතික ගොනු බෙදාහැරීමේ ක්‍රමය",
      "deliveryMethod": "බෙදාහැරීමේ ක්‍රමය",
      "otherDeliveryMethod": "වෙනත් බෙදාහැරීමේ ක්‍රමය",
      "instituteType": "ආයතන වර්ගය",
      "appealMatter": "අභියාචනා කරුණ",
      "originalCourt": "මුල් අධිකරණය",
      "judgementOrder": "තීන්දුව / නියෝගය",
      "corporateInstitute": "සංස්ථාගත ආයතනය",
      "otherInstituteName": "වෙනත් ආයතන නම",
      "plaintiffApplicantName": "වෙන්නේකරු / ඉල්ලුම්කරුගේ නම",
      "defendantRespondentName": "ප්‍රතිවාදියා / ප්‍රතිචෝදිතයාගේ නම",
      "selectOneOfFollowing": "පහතින් එකක් තෝරන්න",
      "otherInvolvedInstitutions": "වෙනත් සම්බන්ධිත ආයතන",
      "legalOfficerName": "නීති නිලධාරියාගේ / භාර නිලධාරියාගේ නම",
      "legalOfficerNameAlt": "නීති නිලධාරියා/ භාර නිලධාරියාගේ නම",
      "hasActionInstituted": "ක්‍රියාමාර්ගය ආරම්භ කර තිබේද?",
      "courtType": "අධිකරණ වර්ගය",
      "courtTypeOther": "අධිකරණ වර්ගය (වෙනත්)",
      "courtName": "අධිකරණ නම",
      "publicCorporationNames": "පොදු සංස්ථා නම(ය)",
      "subjectOfDispute": "විවාදයේ විෂය",
      "incidentOccurredDate": "සිද්ධිය සිදු වූ දිනය",
      "nextStepOfCase": "නඩුවේ ඊළඟ පියවර",
      "nextDateOfCase": "නඩුවේ ඊළඟ දිනය",
      "countryInvolved": "සම්බන්ධිත රට",
      "directionOfRequest": "ඉල්ලීමේ දිශාව",
      "accusedName": "චෝදනාකරුගේ නම",
      "nationality": "ජාතිකත්වය",
      "countryOfOrigin": "මුල් රට",
      "passportIdNumber": "ගමන් බලපත්‍ර / හැඳුනුම්පත් අංකය",
      "currentCustodyStatus": "වර්තමාන භාරකරණ තත්ත්වය",
      "custodialAuthority": "භාරකරණ අධිකාරිය",
      "lastKnownLocation": "අවසන් දන්නා ස්ථානය",
      "arrestWarrantAvailable": "අත්අඩංගු වරෙන්තුව තිබේද",
      "warrantReference": "වරෙන්තු යොමුව",
      "applicableTreatyArrangement": "අදාළ ගිවිසුම/සැලසුම",
      "requestorName": "ඉල්ලුම්කරුගේ නම",
      "nicPassportNumber": "ජා.හැ./ ගමන් බලපත්‍ර අංකය",
      "isSriLankanCitizen": "ඉල්ලුම්කරු ශ්‍රී ලංකා පුරවැසියෙක්ද?",
      "address": "ලිපිනය",
      "specificPublicAuthorityName": "නිශ්චිත පොදු අධිකාරියේ නම",
      "informationRequestedTimePeriod": "තොරතුරු ඉල්ලූ කාල සීමාව",
      "requestedInformationDetails": "ඉල්ලූ තොරතුරු විස්තර",
      "preferredMethodOfAccess": "කැමති ප්‍රවේශ ක්‍රමය",
      "preferredLanguageForResponse": "ප්‍රතිචාරය සඳහා කැමති භාෂාව",
      "involvesLifeOrPersonalLiberty": "මෙම ඉල්ලීම පුරවැසියෙකුගේ ජීවිතය හෝ පෞද්ගලික නිදහස සම්බන්ධ වේද?",
      "justification": "සාධාරණීකරණය",
      "additionalNotes": "අතිරේක සටහන්",
      "caseMatter": "නඩු කරුණ",
      "name": "නම",
      "nicIdentificationNumber": "ජා.හැ. / හැඳුනුම්පත් අංකය",
      "email": "විද්‍යුත් තැපෑල",
      "representedByAttorney": "නීතිඥයෙකු විසින් නියෝජනය කරයිද",
      "attorneyName": "නීතිඥයාගේ නම",
      "attorneyContactNumber": "නීතිඥයාගේ දුරකථන අංකය",
      "respondentNames": "වගඋත්තරකරුගේ නම(ය)",
      "respondentType": "වගඋත්තරකරු වර්ගය",
      "numberOfRespondents": "වගඋත්තරකරුවන් ගණන",
      "respondentAddress": "වගඋත්තරකරුගේ ලිපිනය",
      "partyBodyType": "පාර්ශ්ව ආයතන වර්ගය",
      "status": "තත්ත්වය",
      "petitionerName": "පෙත්සම්කරුගේ නම",
      "nic": "ජාතික හැඳුනුම්පත් අංකය",
      "attorneyContact": "නීතිඥ සම්බන්ධතාව",
      "citizenOfSriLanka": "ශ්‍රී ලංකා පුරවැසියෙක්",
      "involvesLifeOrPersonalLibertyShort": "ජීවිතය හෝ පෞද්ගලික නිදහස සම්බන්ධ වේ",
      "hasPreviousAdvice": "පෙර උපදෙස් ලැබී තිබේද?",
      "previousAdviceAttachment": "පෙර උපදෙස් ඇමුණුම",
      "connectedAdviceCase": "සම්බන්ධිත උපදේශන නඩුවද?",
      "connectedAdviceCaseDetails": "සම්බන්ධිත උපදේශන නඩු විස්තර",
      "isAppealMatter": "මෙය අභියාචනා කරුණක්ද?",
      "judgementOrderShort": "තීන්දුව / නියෝගය",
      "governmentDepartment": "රජයේ දෙපාර්තමේන්තුව",
      "corporation": "සංස්ථාව",
      "criminalMatter": "අපරාධ කරුණ",
      "civilMatter": "සිවිල් කරුණ",
      "governmentMinistryDepartment": "රජයේ අමාත්‍යාංශය / දෙපාර්තමේන්තුව / වෙනත් නීතිමය ඒකාබද්ධතාවක් නොමැති ආයතන",
      "publicCorporationStatutory": "පොදු නිවේශිත සංස්ථාව / නීතිමය මණ්ඩලය / රජයේ අයිතියට අයත් සංස්ථාව / වෙනත් නීතිමය ඒකාබද්ධ ආයතන",
      "governmentMinistryDepartmentAlt": "රජයේ අමාත්‍යාංශය/ දෙපාර්තමේන්තුව/ වෙනත් නීතිමය ඒකාබද්ධතාවක් නොමැති ආයතන",
      "publicCorporationStatutoryAlt": "පොදු නිවේශිත සංස්ථාව/ නීතිමය මණ්ඩලය/ රජයේ අයිතිය下的 සංස්ථාව/ වෙනත් නීතිමය ඒකාබද්ධ ආයතන",
      "accusedSuspectName": "චෝදනාකරු / සැකකරුගේ නම",
      "accusedSuspectStatus": "චෝදනාකරු / සැකකරුගේ තත්ත්වය",
      "statusOther": "තත්ත්වය (වෙනත්)",
      "reason": "හේතුව",
      "petitionerAddress": "පෙත්සම්කරුගේ ලිපිනය",
      "nextStepOther": "නඩුවේ වෙනත් ඊළඟ පියවර",
      "preferredLanguage": "වඩාත් කැමති භාෂාව",
      "connectedMattersAdvises": "සම්බන්ධ කාරණා (උපදෙස්/නඩු) තිබේද?",
      "applicableAreas": "අදාළ ප්‍රදේශ",
      "available": "තිබේ",
      "publicCorporationName": "පොදු සංස්ථාවේ නම",
      "nextStepOfCaseIfApplicable": "නඩුවේ ඊළඟ පියවර (අදාළ නම්)",
      "hasPreviousAdviceOnMatter": "මෙම කරුණ සම්බන්ධයෙන් පෙර උපදෙස් ලැබී තිබේද?",
      "previousAdviceAttachmentIfYes": "ඔව් නම්, පෙර උපදෙස් අමුණන්න",
      "noPreviousAdviceDocuments": "පෙර උපදෙස් ලේඛන උඩුගත කර නැත.",
      "connectedCaseRelevant": "ඉල්ලූ උපදෙස් සඳහා අදාළ සම්බන්ධ නඩුවක් තිබේද?",
      "connectedCaseDetails": "ඔව් නම්, නඩු විස්තර අංගය ඇතුළත් කරන්න (පාර්ශ්ව විස්තර)"
    },
    "documents": {
      "documentType": "ලේඛන වර්ගය",
      "status": "තත්ත්වය",
      "fileOrReason": "ගොනුව / හේතුව",
      "uploaded": "උඩුගත කර ඇත",
      "notUploaded": "උඩුගත කර නැත",
      "noDocumentsDeclared": "ලේඛන ප්‍රකාශ කර නැත.",
      "uploading": "උඩුගත කරමින්…",
      "loadingChecklist": "ලේඛන පරීක්ෂා ලැයිස්තුව පූරණය වෙමින්…",
      "selectCategoryForDocs": "අවශ්‍ය ලේඛන පූරණය කිරීමට ගොනු කාණ්ඩය තෝරන්න.",
      "noDocsConfigured": "තෝරාගත් උප ගොනු කාණ්ඩය සඳහා ලේඛන සකසා නැත."
    },
    "edit": "සංස්කරණය",
    "criminal": {
      "steps": {
        "1": "නඩු දළ විශ්ලේෂණය",
        "2": "පීඩිත විස්තර",
        "3": "වරද සහ චෝදනාකරු විස්තර",
        "4": "ඉදිරිපත් කිරීම සහ භෞතික ගොනු බෙදාහැරීම",
        "5": "ලේඛන උඩුගත කරන්න"
      }
    },
    "criminalAppellate": {
      "steps": {
        "1": "නඩු දළ විශ්ලේෂණය",
        "2": "පාර්ශ්ව විස්තර",
        "3": "කාලරාමුව",
        "4": "ඉදිරිපත් කිරීම සහ භෞතික ගොනු බෙදාහැරීම",
        "5": "ලේඛන උඩුගත කරන්න"
      }
    },
    "civilLitigation": {
      "steps": {
        "1": "නඩු දළ විශ්ලේෂණය",
        "2": "පාර්ශ්ව විස්තර",
        "3": "සිද්ධි විස්තර",
        "4": "ඉදිරිපත් කිරීම සහ භෞතික ගොනු බෙදාහැරීම",
        "5": "ලේඛන උඩුගත කරන්න"
      }
    },
    "civilAppellate": {
      "steps": {
        "1": "නඩු දළ විශ්ලේෂණය",
        "2": "පාර්ශ්ව විස්තර",
        "3": "කාලරාමුව",
        "4": "ඉදිරිපත් කිරීම සහ භෞතික ගොනු බෙදාහැරීම",
        "5": "ලේඛන උඩුගත කරන්න"
      }
    },
    "civilAdvise": {
      "steps": {
        "1": "නඩු දළ විශ්ලේෂණය",
        "2": "කාලරාමුව",
        "3": "ඉදිරිපත් කිරීම සහ භෞතික ගොනු බෙදාහැරීම",
        "4": "ලේඛන උඩුගත කරන්න"
      }
    },
    "attorneyGeneral": {
      "steps": {
        "1": "නඩු දළ විශ්ලේෂණය",
        "2": "පාර්ශ්ව විස්තර",
        "3": "සිද්ධි විස්තර",
        "4": "පීඩිත විස්තර",
        "5": "වරද සහ චෝදනාකරු විස්තර",
        "6": "චෝදනාකරු විස්තර - ප්‍රත්‍යර්පණය සහ MLA",
        "7": "නීති සහ ප්‍රතිදාන/නීති සහයෝගීතා",
        "8": "පෙත්සම්කරු විස්තර",
        "9": "තොරතුරු දැනගැනීමේ අයිතිය",
        "10": "කාලරාමුව",
        "11": "ඉදිරිපත් කිරීම",
        "12": "ලේඛන උඩුගත කරන්න"
      },
      "stepLines": {
        "5": "වරද සහ චෝදනාකරු\nවිස්තර",
        "6": "චෝදනාකරු විස්තර\nප්‍රත්‍යර්පණය සහ MLA",
        "7": "නීති සහ\nප්‍රතිදාන/නීති සහයෝගීතා",
        "8": "පෙත්සම්කරු\nවිස්තර",
        "9": "තොරතුරු දැනගැනීමේ\nඅයිතිය",
        "12": "ලේඛන\nඋඩුගත කරන්න"
      }
    },
    "extraditionMla": {
      "steps": {
        "1": "නඩු දළ විශ්ලේෂණය",
        "2": "චෝදනාකරු විස්තර",
        "3": "නීති සහ ප්‍රතිදාන/නීති සහයෝගීතා",
        "4": "කාලරාමුව",
        "5": "ඉදිරිපත් කිරීම සහ භෞතික ගොනු බෙදාහැරීම",
        "6": "ලේඛන උඩුගත කරන්න"
      },
      "reviewSteps": {
        "3": "නීති සහ ප්‍රතිදාන/නීති සහයෝගීතා වාර්තා විස්තර",
        "1categorization": "වර්ගීකරණය",
        "1intake": "නඩු ලබාගැනීමේ විස්තර"
      }
    },
    "nomination": {
      "steps": {
        "1": "නඩු දළ විශ්ලේෂණය",
        "2": "කාලරාමුව",
        "3": "ඉදිරිපත් කිරීම සහ භෞතික ගොනු බෙදාහැරීම",
        "4": "ලේඛන උඩුගත කරන්න"
      }
    },
    "publicPetition": {
      "steps": {
        "1": "නඩු දළ විශ්ලේෂණය",
        "2": "සම්බන්ධිත පාර්ශ්ව",
        "3": "කාලරාමුව",
        "4": "ඉදිරිපත් කිරීම සහ භෞතික ගොනු බෙදාහැරීම",
        "5": "ලේඛන උඩුගත කරන්න"
      }
    },
    "rightToInformation": {
      "steps": {
        "1": "නඩු දළ විශ්ලේෂණය",
        "2": "කාලරාමුව",
        "3": "ඉදිරිපත් කිරීම",
        "4": "ලේඛන උඩුගත කරන්න"
      }
    }
  },
  "admin": {
    "userAdministration": "පරිශීලක පරිපාලනය",
    "shared": {
      "code": "කේතය",
      "description": "විස්තරය",
      "cancelChanges": "වෙනස්කම් අවලංගු කරන්න",
      "cancelChangesMessage": "ඔබට අවලංගු කිරීමට අවශ්‍ය බව විශ්වාසද? සුරකි නොකළ වෙනස්කම් නැති වනු ඇත.",
      "requestFailed": "ඉල්ලීම අසාර්ථක විය.",
      "invalidEmail": "වලංගු ඊ-තැපැල් ලිපිනයක් ඇතුළත් කරන්න.",
      "add": "එක් කරන්න",
      "adding": "එක් කරමින්…",
      "removeImage": "රූපය ඉවත් කරන්න",
      "upload": "උඩුගත කරන්න",
      "imageUploadFailed": "රූපය උඩුගත කිරීම අසාර්ථක විය.",
      "displayName": "ප්‍රදර්ශන නාමය",
      "selectStatus": "තත්ත්වය තෝරන්න",
      "emailPlaceholderShort": "ඊ-තැපෑල/පරිශීලක නාමය ඇතුළත් කරන්න",
      "agencyName": "ආයතන නාමය",
      "roleName": "භූමිකා නාමය",
      "applicationName": "යෙදුම් නාමය",
      "applicationNames": "යෙදුම් නාම(ය)",
      "assignedUsers": "පවරන ලද පරිශීලකයින්",
      "fileCategory": "ගොනු කාණ්ඩය",
      "subFileCategory": "උප ගොනු කාණ්ඩය",
      "supervisor": "අධීක්ෂක",
      "selectAllPermissions": "සියලු අවසර තෝරන්න",
      "basicInformation": "මූලික තොරතුරු",
      "orderIndex": "ඇණවුම් දර්ශකය",
      "dragToReorder": "නැවත ඇණවුම් කිරීමට ඇදගෙන යන්න",
      "locked": "අගුළු දමා ඇත",
      "loadingOrder": "ඇණවුම පූරණය වෙමින්…",
      "noPermissionsConfigured": "අවසර සකස් කර නැත.",
      "selectedCount": "{{count}} තෝරා ඇත",
      "newRole": "නව භූමිකාව",
      "rolePermissions": "භූමිකා අවසර",
      "applicationCannotChange": "යාවත්කාලීන කිරීමේදී යෙදුම වෙනස් කළ නොහැක."
    },
    "intranetUsers": {
      "title": "අභ්‍යන්තර පරිශීලකයින්",
      "addNewUser": "+ නව පරිශීලකයෙක් එක් කරන්න",
      "tableTitle": "අභ්‍යන්තර පරිශීලක විස්තර",
      "selectUserName": "පරිශීලක නම තෝරන්න",
      "selectUserRole": "පරිශීලක භූමිකාව තෝරන්න",
      "selectDivisionUnit": "අංශය/ඒකකය තෝරන්න",
      "emailPlaceholder": "ඊ-තැපෑල/පරිශීලක නාමය ඇතුළත් කරන්න",
      "selectStatus": "තත්ත්වය තෝරන්න",
      "filterByUserName": "පරිශීලක නම අනුව පෙරහන් කරන්න",
      "userDetails": "පරිශීලක විස්තර",
      "deleteTitle": "පරිශීලකයා මකන්න",
      "entityLabel": "පරිශීලක",
      "editUser": "පරිශීලකයා සංස්කරණය කරන්න",
      "deleteUser": "පරිශීලකයා මකන්න",
      "loadFailed": "පරිශීලකයින් පූරණය කළ නොහැක.",
      "deleteSuccess": "පරිශීලකයා සාර්ථකව මකා ඇත.",
      "deleteFailed": "පරිශීලකයා මැකීමට අසමත් විය.",
      "footerCountNoun": "පරිශීලකයින්"
    },
    "extranetUsers": {
      "title": "බාහිර පරිශීලකයින්",
      "addNewUser": "+ නව පරිශීලකයෙක් එක් කරන්න",
      "tableTitle": "බාහිර පරිශීලක විස්තර",
      "selectAgencyName": "ආයතන නාමය තෝරන්න",
      "agencyUserFullName": "ආයතන පරිශීලකයාගේ සම්පූර්ණ නම",
      "editUser": "පරිශීලකයා සංස්කරණය කරන්න",
      "deleteUser": "පරිශීලකයා මකන්න",
      "deleteTitle": "පරිශීලකයා මකන්න",
      "entityLabel": "පරිශීලක",
      "loadFailed": "පරිශීලකයින් පූරණය කළ නොහැක.",
      "deleteSuccess": "පරිශීලකයා සාර්ථකව මකා ඇත.",
      "deleteFailed": "පරිශීලකයා මැකීමට අසමත් විය.",
      "footerCountNoun": "පරිශීලකයින්"
    },
    "rolesPermissions": {
      "title": "පරිශීලක භූමිකා සහ අවසර",
      "addNewRole": "+ නව භූමිකාවක් එක් කරන්න",
      "tableTitle": "පරිශීලක භූමිකා විස්තර",
      "selectRoleName": "භූමිකා නාමය තෝරන්න",
      "selectApplicationName": "යෙදුම් නාමය තෝරන්න",
      "updateRoleDetails": "භූමිකා විස්තර යාවත්කාලීන කරන්න",
      "viewRoleDetails": "භූමිකා විස්තර බලන්න",
      "updateNotAllowed": "මෙම භූමිකාව සඳහා යාවත්කාලීන කිරීමට අවසර නැත.",
      "updateNotAllowedAria": "භූමිකා විස්තර යාවත්කාලීන කරන්න (අවසර නැත)",
      "deleteRole": "භූමිකාව මකන්න",
      "deleteTitle": "භූමිකාව මකන්න",
      "entityLabel": "භූමිකාව",
      "roleDeletedSuccess": "භූමිකාව සාර්ථකව මකා ඇත.",
      "roleDeleteFailed": "භූමිකාව මැකීමට අසමත් විය.",
      "roleCreatedSuccess": "භූමිකාව සාර්ථකව සාදන ලදී.",
      "roleUpdatedSuccess": "භූමිකාව සාර්ථකව යාවත්කාලීන කරන ලදී."
    },
    "userCategories": {
      "title": "පරිශීලක කාණ්ඩ",
      "addUserCategory": "+ පරිශීලක කාණ්ඩයක් එක් කරන්න",
      "tableTitle": "පරිශීලක කාණ්ඩ විස්තර",
      "selectFileCategory": "ගොනු කාණ්ඩය තෝරන්න",
      "selectSubFileCategory": "උප ගොනු කාණ්ඩය තෝරන්න",
      "selectUserName": "පරිශීලක නම තෝරන්න",
      "selectUserRole": "පරිශීලක භූමිකාව තෝරන්න",
      "selectSupervisor": "අධීක්ෂක තෝරන්න",
      "selectStateAttorney": "රාජ්‍ය නීතිඥ තෝරන්න",
      "editUserCategory": "පරිශීලක කාණ්ඩය සංස්කරණය කරන්න",
      "loadFailed": "පරිශීලක කාණ්ඩ පූරණය කළ නොහැක.",
      "footerCountNoun": "පරිශීලක වර්ගීකරණ",
      "duplicateCombinationError": "\"{{fileCategory}} > {{subFileCategory}}\" සඳහා වින්‍යාසයක් දැනටමත් පවතී. අධීක්ෂක හෝ පරිශීලකයින් වෙනස් කිරීමට, කරුණාකර පවතින වාර්තාව යාවත්කාලීන කරන්න.",
      "editExistingRecord": "පවතින වාර්තාව සංස්කරණය කරන්න →",
      "duplicateCombinationBlockedTooltip": "මෙම කාණ්ඩ සංයෝජනය දැනටමත් පවතී. ඉහත සංස්කරණ සබැඳිය භාවිතා කරන්න."
    },
    "intranetUserForm": {
      "updateTitle": "අභ්‍යන්තර පරිශීලකයා යාවත්කාලීන කරන්න",
      "addTitle": "නව අභ්‍යන්තර පරිශීලකයෙක් එක් කරන්න",
      "sectionTitle": "අභ්‍යන්තර පරිශීලක විස්තර",
      "title": "ශීර්ෂය",
      "firstName": "මුල් නම",
      "lastName": "අවසාන නම",
      "selectTitle": "ශීර්ෂය තෝරන්න",
      "firstNamePlaceholder": "උදා: නිමල්",
      "lastNamePlaceholder": "උදා: සිල්වා",
      "displayNamePlaceholder": "උදා: Mr. නිමල් සිල්වා",
      "emailPlaceholder": "උදා: name@ag.gov.lk",
      "nicPlaceholder": "උදා: 901234567V හෝ N1234567",
      "serviceIdPlaceholder": "සේවා හැඳුනුම් අංකය ඇතුළත් කරන්න",
      "selectUserRole": "පරිශීලක භූමිකාව තෝරන්න",
      "selectDesignation": "තනතුර තෝරන්න",
      "selectUserRoleToAdd": "එක් කිරීමට පරිශීලක භූමිකාව තෝරන්න",
      "addUserRole": "පරිශීලක භූමිකාව එක් කරන්න",
      "noRolesAvailable": "භූමිකා නොමැත",
      "addRole": "භූමිකාව එක් කරන්න",
      "selectRoleFirst": "පළමුව භූමිකාවක් තෝරන්න",
      "defaultRole": "පෙරනිමි භූමිකාව",
      "removeRole": "{{roleName}} ඉවත් කරන්න",
      "atLeastOneRole": "අවම වශයෙන් එක් පරිශීලක භූමිකාවක් තෝරා ගත යුතුය.",
      "noRolesData": "පරිශීලක භූමිකා සඳහා දත්ත නොමැත.",
      "selectRoleThenAdd": "පරිශීලක භූමිකාවක් තෝරා + ක්ලික් කරන්න.",
      "roleResolveFailed": "තෝරාගත් භූමිකාව හඳුනා ගත නොහැක. ලැයිස්තුවෙන් භූමිකාවක් තෝරන්න.",
      "rolesResolveFailed": "භූමිකා එකක් හෝ වැඩි ගණනක් හඳුනා ගත නොහැක. නැවත භූමිකා තෝරන්න.",
      "selectDefaultRole": "පෙරනිමි භූමිකාවක් තෝරන්න.",
      "selectValidDivision": "වලංගු අංශය/ඒකකයක් තෝරන්න.",
      "divisionInvalid": "අංශය/ඒකකය වලංගු නොවේ. නැවත තෝරන්න.",
      "createSuccess": "අභ්‍යන්තර පරිශීලකයා සාර්ථකව සාදන ලදී.",
      "updateSuccess": "අභ්‍යන්තර පරිශීලකයා සාර්ථකව යාවත්කාලීන කරන ලදී."
    },
    "extranetUserForm": {
      "allExtranetUsers": "සියලු බාහිර පරිශීලකයින්",
      "updateTitle": "බාහිර පරිශීලක විස්තර යාවත්කාලීන කරන්න",
      "addTitle": "නව බාහිර පරිශීලකයෙක් එක් කරන්න",
      "sectionTitle": "බාහිර පරිශීලක විස්තර",
      "extranetAgencyName": "බාහිර ආයතන නාමය",
      "selectExtranetAgencyName": "බාහිර ආයතන නාමය තෝරන්න",
      "addNewAgency": "+ නව ආයතනයක් එක් කරන්න",
      "addNewExtranetAgency": "නව බාහිර ආයතනයක් එක් කරන්න",
      "enterExtranetAgencyName": "බාහිර ආයතන නාමය ඇතුළත් කරන්න",
      "agencyNameRequired": "බාහිර ආයතන නාමය අවශ්‍යය.",
      "selectValidAgency": "වලංගු බාහිර ආයතන නාමයක් තෝරන්න.",
      "companyCode": "සමාගම් කේතය",
      "companyCodePlaceholder": "උදා: ABC",
      "brn": "BRN",
      "brnPlaceholder": "BRN ඇතුළත් කරන්න",
      "agencyUserFullName": "ආයතන පරිශීලකයාගේ සම්පූර්ණ නම",
      "agencyUserFullNamePlaceholder": "ආයතන පරිශීලකයාගේ සම්පූර්ණ නම ඇතුළත් කරන්න",
      "displayNamePlaceholder": "උදා: නිමල් පෙරේරා",
      "agencyUserDesignation": "ආයතන පරිශීලකයාගේ තනතුර",
      "agencyUserDesignationPlaceholder": "ආයතන පරිශීලකයාගේ තනතුර ඇතුළත් කරන්න",
      "contactRequired": "සම්බන්ධ අංකය අවශ්‍යය.",
      "createSuccess": "බාහිර පරිශීලකයා සාර්ථකව සාදන ලදී.",
      "updateSuccess": "බාහිර පරිශීලකයා සාර්ථකව යාවත්කාලීන කරන ලදී."
    },
    "roleForm": {
      "listTitle": "පරිශීලක භූමිකා සහ අවසර",
      "updateTitle": "පරිශීලක භූමිකාව යාවත්කාලීන කරන්න",
      "viewTitle": "පරිශීලක භූමිකාව බලන්න",
      "addTitle": "නව පරිශීලක භූමිකාවක් එක් කරන්න",
      "roleNamePlaceholder": "පරිශීලක භූමිකාවේ නම ඇතුළත් කරන්න",
      "codePlaceholder": "උදා: SYS_AD",
      "descriptionPlaceholder": "පරිශීලක භූමිකාවේ විස්තරය ඇතුළත් කරන්න",
      "atLeastOnePermission": "අවම වශයෙන් එක් අවසරයක් хотя бы එක් කළ යුතුය.",
      "atLeastOneApplication": "අවම වශයෙන් එක් යෙදුමක් තෝරන්න.",
      "codeGenerateFailed": "කේතය සෑදිය නොහැක. භූමිකා නාමයක් ඇතුළත් කරන්න.",
      "cannotInactivateWithAssignedUsers": "පරිශීලකයින් පවරා ඇති අතරතුර මෙම භූමිකාව අක්‍රිය ලෙස සලකුණු කළ නොහැක.",
      "createSuccess": "භූමිකාව සාර්ථකව සාදන ලදී.",
      "updateSuccess": "භූමිකාව සාර්ථකව යාවත්කාලීන කරන ලදී."
    },
    "userCategoryForm": {
      "updateTitle": "පරිශීලක කාණ්ඩය යාවත්කාලීන කරන්න",
      "addTitle": "පරිශීලක කාණ්ඩයක් එක් කරන්න",
      "userNames": "පරිශීලක නම(ය)",
      "selectFileCategoryFirst": "පළමුව ගොනු කාණ්ඩය තෝරන්න",
      "searchSelectUsers": "පරිශීලකයින් සොයා තෝරන්න…",
      "noUsersFound": "පරිශීලකයින් හමු නොවීය",
      "createSuccess": "පරිශීලක කාණ්ඩය සාර්ථකව සාදන ලදී.",
      "updateSuccess": "පරිශීලක කාණ්ඩය සාර්ථකව යාවත්කාලීන කරන ලදී."
    }
  },
  "metadata": {
    "subCategories": {
      "title": "උප කාණ්ඩය කළමනාකරණය",
      "addSubCategory": "+ උප කාණ්ඩය සාදන්න",
      "tableTitle": "උප කාණ්ඩ විස්තර",
      "selectFileCategory": "ගොනු කාණ්ඩය තෝරන්න",
      "selectSubFileCategory": "උප ගොනු කාණ්ඩය තෝරන්න",
      "updateSubCategory": "උප කාණ්ඩය යාවත්කාලීන කරන්න",
      "loadFailed": "උප කාණ්ඩ පූරණය කිරීම අසාර්ථක විය.",
      "footerCountNoun": "උප කාණ්ඩ"
    },
    "subCategoryForm": {
      "addTitle": "උප කාණ්ඩය සාදන්න",
      "updateTitle": "උප කාණ්ඩය යාවත්කාලීන කරන්න",
      "bindName": "Bind Name",
      "namePlaceholder": "උප කාණ්ඩ නාමය ඇතුළත් කරන්න",
      "codePlaceholder": "නාමයෙන් ජනනය වේ",
      "codeLengthError": "කේතය ඉංග්‍රීසි අකුරු 3–5 විය යුතුය.",
      "applicableArea": "අදාළ ප්‍රදේශ",
      "applicableAreaItemPlaceholder": "අදාළ ප්‍රදේශය ඇතුළත් කරන්න",
      "addApplicableArea": "අදාළ ප්‍රදේශයක් එක් කරන්න",
      "applicableAreaEmptyAddBlocked": "තවත් එකක් එක් කිරීමට පෙර අදාළ ප්‍රදේශයක් ඇතුළත් කරන්න.",
      "applicableAreaDuplicateError": "මෙම අදාළ ප්‍රදේශය දැනටමත් පවතී.",
      "removeApplicableArea": "අදාළ ප්‍රදේශය ඉවත් කරන්න",
      "documentTypes": "ලේඛන වර්ග",
      "documentOptional": "අනිවාර්ය නොවේ",
      "documentOptionalHint": "සලකුණු කළහොත්, මෙම ලේඛනය උප කාණ්ඩයේ පිරික්සුම් ලැයිස්තුව සඳහා අනිවාර්ය නොවේ.",
      "selectAllDocumentTypes": "සියලු ලේඛන වර්ග තෝරන්න",
      "createSuccess": "උප කාණ්ඩය සාර්ථකව සාදන ලදී.",
      "updateSuccess": "උප කාණ්ඩය සාර්ථකව යාවත්කාලීන කරන ලදී."
    },
    "courts": {
      "title": "අධිකරණ නාම",
      "addCourt": "+ අධිකරණ නාමය එක් කරන්න",
      "tableTitle": "අධිකරණ නාම විස්තර",
      "courtName": "අධිකරණ නාමය",
      "courtNamePlaceholder": "අධිකරණ නාමය ඇතුළත් කරන්න",
      "courtCode": "අධිකරණ කේතය",
      "courtType": "අධිකරණ වර්ගය",
      "division": "අංශය",
      "province": "පළාත",
      "district": "දිස්ත්‍රික්කය",
      "selectCourtType": "අධිකරණ වර්ගය තෝරන්න",
      "selectDivision": "අංශය තෝරන්න",
      "selectProvince": "පළාත තෝරන්න",
      "selectDistrict": "දිස්ත්‍රික්කය තෝරන්න",
      "selectProvinceFirst": "පළමුව පළාත තෝරන්න",
      "selectStatus": "තත්ත්වය තෝරන්න",
      "updateCourt": "අධිකරණ නාමය යාවත්කාලීන කරන්න",
      "loadFailed": "අධිකරණ නාම පූරණය කිරීමට අසමත් විය.",
      "footerCountNoun": "අධිකරණ නාම"
    },
    "courtForm": {
      "addTitle": "අධිකරණ නාමය එක් කරන්න",
      "updateTitle": "අධිකරණ නාමය යාවත්කාලීන කරන්න",
      "namePlaceholder": "අධිකරණ නාමය ඇතුළත් කරන්න",
      "selectCourtType": "අධිකරණ වර්ගය තෝරන්න",
      "selectDivision": "අංශය තෝරන්න",
      "cancelConfirm": "වෙනස්කම් සුරැකීමෙන් තොරව අවලංගු කිරීමට ඔබට විශ්වාසද?",
      "createSuccess": "අධිකරණ නාමය සාර්ථකව එක් කරන ලදී.",
      "updateSuccess": "අධිකරණ නාමය සාර්ථකව යාවත්කාලීන කරන ලදී."
    },
    "languages": {
      "title": "භාෂා වර්ග",
      "addLanguage": "+ භාෂා වර්ගය එක් කරන්න",
      "tableTitle": "භාෂා වර්ග විස්තර",
      "languageName": "භාෂා වර්ගය",
      "languageCode": "භාෂා කේතය",
      "updateLanguage": "භාෂා වර්ගය යාවත්කාලීන කරන්න",
      "loadFailed": "භාෂා වර්ග පූරණය කිරීමට අසමත් විය.",
      "footerCountNoun": "භාෂා වර්ග"
    },
    "languageForm": {
      "addTitle": "භාෂා වර්ගය එක් කරන්න",
      "updateTitle": "භාෂා වර්ගය යාවත්කාලීන කරන්න",
      "namePlaceholder": "භාෂා වර්ගය ඇතුළත් කරන්න",
      "cancelConfirm": "වෙනස්කම් සුරැකීමෙන් තොරව අවලංගු කිරීමට ඔබට විශ්වාසද?",
      "createSuccess": "භාෂා වර්ගය සාර්ථකව එක් කරන ලදී.",
      "updateSuccess": "භාෂා වර්ගය සාර්ථකව යාවත්කාලීන කරන ලදී."
    },
    "countries": {
      "title": "රට කළමනාකරණය",
      "addCountry": "+ රට සාදන්න",
      "tableTitle": "රට විස්තර",
      "countryName": "රටේ නාමය",
      "countryNamePlaceholder": "රටේ නාමය ඇතුළත් කරන්න",
      "countryCode": "රටේ කේතය",
      "description": "විස්තරය",
      "displayOrder": "පෙන්වීමේ අනුපිළිවෙල",
      "selectStatus": "තත්ත්වය තෝරන්න",
      "updateCountry": "රට යාවත්කාලීන කරන්න",
      "loadFailed": "රට පූරණය කිරීමට අසමත් විය.",
      "footerCountNoun": "රට"
    },
    "countryForm": {
      "addTitle": "රට සාදන්න",
      "updateTitle": "රට යාවත්කාලීන කරන්න",
      "namePlaceholder": "රටේ නාමය ඇතුළත් කරන්න",
      "descriptionPlaceholder": "විස්තරය ඇතුළත් කරන්න",
      "cancelConfirm": "වෙනස්කම් සුරැකීමෙන් තොරව අවලංගු කිරීමට ඔබට විශ්වාසද?",
      "createSuccess": "රට සාර්ථකව සාදන ලදී.",
      "updateSuccess": "රට සාර්ථකව යාවත්කාලීන කරන ලදී."
    },
    "nationalities": {
      "title": "ජාතිකත්ව කළමනාකරණය",
      "addNationality": "+ ජාතිකත්වය සාදන්න",
      "tableTitle": "ජාතිකත්ව විස්තර",
      "nationalityName": "නාමය",
      "nationalityNamePlaceholder": "ජාතිකත්ව නාමය ඇතුළත් කරන්න",
      "nationalityCode": "කේතය",
      "description": "විස්තරය",
      "descriptionPlaceholder": "විස්තරය ඇතුළත් කරන්න",
      "displayOrder": "ප්‍රදර්ශන අනුපිළිවෙල",
      "updatedAt": "යාවත්කාලීන කළ වේලාව",
      "selectStatus": "තත්ත්වය තෝරන්න",
      "updateNationality": "ජාතිකත්වය යාවත්කාලීන කරන්න",
      "viewTitle": "ජාතිකත්ව විස්තර",
      "loadFailed": "ජාතිකත්ව පූරණය කිරීමට අසමත් විය.",
      "footerCountNoun": "ජාතිකත්ව"
    },
    "nationalityForm": {
      "addTitle": "ජාතිකත්වය සාදන්න",
      "updateTitle": "ජාතිකත්වය යාවත්කාලීන කරන්න",
      "namePlaceholder": "ජාතිකත්ව නාමය ඇතුළත් කරන්න",
      "cancelConfirm": "වෙනස්කම් සුරැකීමෙන් තොරව අවලංගු කිරීමට ඔබට විශ්වාසද?",
      "createSuccess": "ජාතිකත්වය සාර්ථකව සාදන ලදී.",
      "updateSuccess": "ජාතිකත්වය සාර්ථකව යාවත්කාලීන කරන ලදී."
    },
    "policeStations": {
      "title": "පොලිස් ස්ථාන",
      "addPoliceStation": "+ පොලිස් ස්ථානය එකතු කරන්න",
      "tableTitle": "පොලිස් ස්ථාන විස්තර",
      "name": "පොලිස් ස්ථානය",
      "code": "කේතය",
      "policeDivision": "පොලිස් විභාගය",
      "district": "දිස්ත්‍රික්කය",
      "selectDistrict": "දිස්ත්‍රික්කය තෝරන්න",
      "selectPoliceDivision": "පොලිස් විභාගය තෝරන්න",
      "updatePoliceStation": "පොලිස් ස්ථානය යාවත්කාලීන කරන්න",
      "loadFailed": "පොලිස් ස්ථාන පූරණය කිරීම අසාර්ථක විය.",
      "footerCountNoun": "පොලිස් ස්ථාන"
    },
    "policeStationForm": {
      "addTitle": "පොලිස් ස්ථානය සාදන්න",
      "updateTitle": "පොලිස් ස්ථානය යාවත්කාලීන කරන්න",
      "name": "නාමය",
      "namePlaceholder": "පොලිස් ස්ථාන නාමය ඇතුළත් කරන්න",
      "nameLengthError": "නාමය අක්ෂර 100කට වැඩියෙන් විය නොහැක.",
      "policeDivision": "පොලිස් විභාගය",
      "selectPoliceDivision": "පොලිස් විභාගය තෝරන්න",
      "description": "විස්තරය",
      "descriptionPlaceholder": "විස්තරය ඇතුළත් කරන්න",
      "active": "සක්‍රීය",
      "createSuccess": "පොලිස් ස්ථානය සාර්ථකව සාදන ලදී.",
      "updateSuccess": "පොලිස් ස්ථානය සාර්ථකව යාවත්කාලීන කරන ලදී."
    },
    "letterTemplates": {
      "title": "ලිපි අච්චු",
      "tableTitle": "ලිපි අච්චු විස්තර",
      "templateName": "ලිපි අච්චු නාමය",
      "lastUpdatedAt": "අවසන් යාවත්කාලීන කළ දිනය",
      "lastUpdatedBy": "අවසන් යාවත්කාලීන කළේ",
      "selectFileCategory": "ගොනු කාණ්ඩය තෝරන්න",
      "selectFileCategoryFirst": "පළමුව ගොනු කාණ්ඩය තෝරන්න",
      "selectSubFileCategory": "උප ගොනු කාණ්ඩය තෝරන්න",
      "selectSubFileCategoryFirst": "පළමුව උප ගොනු කාණ්ඩය තෝරන්න",
      "selectTemplateName": "ලිපි අච්චු නාමය තෝරන්න",
      "selectStatus": "තත්ත්වය තෝරන්න",
      "editTemplateName": "අච්චු නාමය සංස්කරණය කරන්න",
      "loadFailed": "ලිපි අච්චු පූරණය කිරීම අසාර්ථක විය.",
      "footerCountNoun": "ලිපි අච්චු"
    },
    "letterTemplateForm": {
      "updateTitle": "අච්චු නාමය සංස්කරණය කරන්න",
      "namePlaceholder": "ලිපි අච්චු නාමය ඇතුළත් කරන්න",
      "viewTemplate": "ලිපි අච්චුව බලන්න",
      "previewUnavailable": "ලිපි අච්චු පෙරදසුන ලබා ගත නොහැක.",
      "cancelConfirm": "සුරකි නොමැති වෙනස්කම් සමඟ අවලංගු කිරීමට අවශ්‍යද?",
      "updateSuccess": "ලිපි අච්චුව සාර්ථකව යාවත්කාලීන කරන ලදී."
    },
    "subsidiaryTasks": {
      "title": "උප කාර්යයන්",
      "addSubsidiaryTask": "+ උප කාර්යය එකතු කරන්න",
      "tableTitle": "උප කාර්ය විස්තර",
      "subsidiaryTask": "උප කාර්යය",
      "description": "විස්තරය",
      "lastUpdatedAt": "අවසන් යාවත්කාලීන කළ දිනය",
      "selectSubsidiaryTask": "උප කාර්යය තෝරන්න",
      "selectStatus": "තත්ත්වය තෝරන්න",
      "editSubsidiaryTask": "උප කාර්යය සංස්කරණය කරන්න",
      "loadFailed": "උප කාර්යයන් පූරණය කිරීම අසාර්ථක විය.",
      "footerCountNoun": "උප කාර්යයන්"
    },
    "subsidiaryTaskForm": {
      "addTitle": "නව උප කාර්යය එකතු කරන්න",
      "updateTitle": "උප කාර්යය සංස්කරණය කරන්න",
      "namePlaceholder": "උප කාර්යය ඇතුළත් කරන්න",
      "descriptionPlaceholder": "විස්තරය ඇතුළත් කරන්න",
      "cancelConfirm": "සුරකි නොමැති වෙනස්කම් සමඟ අවලංගු කිරීමට අවශ්‍යද?",
      "createSuccess": "උප කාර්යය සාර්ථකව එකතු කරන ලදී.",
      "updateSuccess": "උප කාර්යය සාර්ථකව යාවත්කාලීන කරන ලදී."
    },
    "caseScenarios": {
      "title": "නඩු අවස්ථා",
      "addCaseScenario": "+ නඩු අවස්ථාව එකතු කරන්න",
      "tableTitle": "නඩු අවස්ථා විස්තර",
      "titleColumn": "ශීර්ෂය",
      "description": "විස්තරය",
      "lastUpdatedAt": "අවසන් යාවත්කාලීන කළ දිනය",
      "selectTitle": "ශීර්ෂය තෝරන්න",
      "selectStatus": "තත්ත්වය තෝරන්න",
      "editCaseScenario": "නඩු අවස්ථාව සංස්කරණය කරන්න",
      "loadFailed": "නඩු අවස්ථා පූරණය කිරීම අසාර්ථක විය.",
      "footerCountNoun": "නඩු අවස්ථා",
      "infoPanelTitle": "නඩු අවස්ථා",
      "infoEmpty": "නඩු අවස්ථා නොමැත.",
      "infoLoadFailed": "නඩු අවස්ථා පූරණය කළ නොහැක."
    },
    "caseScenarioForm": {
      "addTitle": "නව නඩු අවස්ථාව එකතු කරන්න",
      "updateTitle": "නඩු අවස්ථාව සංස්කරණය කරන්න",
      "titlePlaceholder": "ශීර්ෂය ඇතුළත් කරන්න",
      "descriptionPlaceholder": "විස්තරය ඇතුළත් කරන්න",
      "uploadPdf": "උඩුගත කරන්න",
      "upload": "උඩුගත කරන්න",
      "view": "බලන්න",
      "viewDocument": "{{name}} පෙරදසුන",
      "removeDocument": "{{name}} ඉවත් කරන්න",
      "uploading": "උඩුගත වෙමින්…",
      "remove": "ඉවත් කරන්න",
      "removePdfTitle": "PDF ඉවත් කරන්න",
      "removePdfConfirm": "උඩුගත කළ PDF ලේඛනය ඉවත් කිරීමට අවශ්‍යද?",
      "removeSuccess": "PDF ලේඛනය සාර්ථකව ඉවත් කරන ලදී.",
      "removeFailed": "PDF ලේඛනය ඉවත් කළ නොහැක.",
      "removing": "ඉවත් කරමින්…",
      "pdfRequired": "PDF ලේඛනයක් අවශ්‍ය වේ.",
      "uploadFailed": "PDF ලේඛනය උඩුගත කළ නොහැක.",
      "cancelConfirm": "සුරකි නොමැති වෙනස්කම් සමඟ අවලංගු කිරීමට අවශ්‍යද?",
      "createSuccess": "නඩු අවස්ථාව සාර්ථකව එකතු කරන ලදී.",
      "updateSuccess": "නඩු අවස්ථාව සාර්ථකව යාවත්කාලීන කරන ලදී."
    }
  },
  "tasks": {
    "shared": {
      "fileRefNo": "ගොනු යොමු අංකය",
      "fileCategory": "ගොනු කාණ්ඩය",
      "subFileCategory": "උප ගොනු කාණ්ඩය",
      "submittedAgency": "ඉදිරිපත් කළ ආයතනය",
      "taskStatus": "කාර්ය තත්ත්වය",
      "currentWorkflowStage": "වත්මන් වැඩ පිළිවෙල අදියර",
      "timeRemaining": "ඉතිරි කාලය/ කල් ඉකුත් වූ කාලය",
      "urgencyLevel": "අත්‍යවශ්‍යතා මට්ටම",
      "assignedOfficer": "අනුයෝජිත නිලධාරී",
      "caseNumber": "නඩු අංකය",
      "submittedAt": "ඉදිරිපත් කළ වේලාව",
      "createdAt": "සාදන ලද වේලාව",
      "supervisor": "අධීක්ෂක",
      "currentAssignee": "වත්මන් භාරකරු",
      "overdueTime": "කල් ඉකුත් වූ කාලය",
      "taskDetails": "කාර්ය විස්තර",
      "duplicateCase": "නඩුව පිටපත් කරන්න",
      "duplicating": "පිටපත් කරමින්",
      "transferCase": "නඩුව මාරු කරන්න",
      "transferring": "මාරු කරමින්",
      "downloadCoverNote": "සාරාංශ සටහන බාගත කරන්න",
      "continueDraft": "කෙටුම්පත දිගටම කරගෙන යන්න",
      "opening": "විවෘත කරමින්",
      "removeDraft": "කෙටුම්පත ඉවත් කරන්න",
      "viewTaskCaseDetails": "කාර්ය/නඩු විස්තර බලන්න",
      "updateTaskCaseDetails": "කාර්ය/නඩු විස්තර යාවත්කාලීන කරන්න",
      "retrievePhysicalFile": "භෞතික ගොනුව ලබා ගන්න",
      "markAsRead": "කියවූ ලෙස සලකුණු කරන්න",
      "markAsUnread": "නොකියවූ ලෙස සලකුණු කරන්න",
      "updating": "යාවත්කාලීන කරමින්",
      "viewTaskCaseDetailsShort": "කාර්ය/නඩු විස්තර බලන්න",
      "configureAssignment": "අනුයෝජනය වින්‍යාස කරන්න",
      "linkedCasesTitle": "සම්බන්ධ කාර්ය/නඩු",
      "viewLinkedCases": "සම්බන්ධ කාර්ය/නඩු බලන්න",
      "linkedCasesUnavailable": "සම්බන්ධ කාර්ය/නඩු නොමැත",
      "noLinkedCases": "මෙම කාර්යය සඳහා සම්බන්ධ කාර්ය/නඩු නොමැත.",
      "previousBack": "‹ ආපසු",
      "nextForward": "ඊළඟ ›"
    },
    "cases": {
      "breadcrumb": "කාර්ය සහ නඩු",
      "title": "කාර්ය සහ නඩු",
      "createCaseRequest": "නඩු ඉල්ලීමක් සාදන්න",
      "loadFailed": "කාර්ය සහ නඩු පූරණය කළ නොහැක.",
      "notificationUpdateFailed": "දැනුම්දීම් තත්ත්වය යාවත්කාලීන කළ නොහැක.",
      "duplicateFailed": "නඩුව පිටපත් කිරීම අසාර්ථක විය. නැවත උත්සාහ කරන්න.",
      "duplicateSuccess": "නඩුව සාර්ථකව පිටපත් කරන ලදී. නව කෙටුම්පතක් සාදන ලදී.",
      "transferFailed": "නඩුව මාරු කිරීමට අසමත් විය. කරුණාකර නැවත උත්සාහ කරන්න.",
      "transferSuccess": "නඩුව සාර්ථකව මාරු කරන ලදී. නීතිමය නඩු කෙටුම්පත විවෘත කරන ලදී.",
      "deleteDraftFailed": "කෙටුම්පත මකා දැමීම අසාර්ථක විය.",
      "deleteDraftSuccess": "කෙටුම්පත සාර්ථකව මකා දමන ලදී.",
      "retrievalFailed": "භෞතික ගොනුව ලබා ගැනීමට ඉල්ලීම අසාර්ථක විය.",
      "retrievalSuccess": "භෞතික ගොනුව ලබා ගැනීම ආරම්භ කරන ලදී. වාර්තා කාමරයට දැනුම් දෙන ලදී.",
      "deleteTitle": "නඩු ඉල්ලීම මකන්න",
      "deleteMessage": "මකා දැමීමට අවශ්‍යද? මෙම ක්‍රියාව අහෝසි කළ නොහැක.",
      "activeTab": "සක්‍රිය කාර්ය සහ නඩු",
      "completedTab": "සම්පූර්ණ කළ කාර්ය සහ නඩු",
      "myActiveTab": "මගේ සක්‍රිය කාර්ය සහ නඩු",
      "linkedActiveTab": "මගේ සම්බන්ධ සක්‍රිය කාර්ය සහ නඩු",
      "createdCaseRequestsTab": "සාදන ලද නඩු ඉල්ලීම්",
      "tableTitle": "කාර්ය සහ නඩු විස්තර",
      "newNotificationLegend": "නව දැනුම්දීමක් ලැබී ඇත",
      "forwardedTaskLegend": "ඉදිරියට යැවූ කාර්ය",
      "newSubTaskLegend": "නව උප කාර්ය යොදා ඇත"
    },
    "assign": {
      "breadcrumb": "කාර්ය පවරන්න",
      "breadcrumbAssigned": "කාර්ය පවරන්න — පවරූ කාර්ය",
      "breadcrumbUnassigned": "කාර්ය පවරන්න — පවර නොකළ කාර්ය",
      "breadcrumbReallocation": "කාර්ය පවරන්න — නැවත පවරීම් ඉල්ලීම්",
      "title": "කාර්ය පවරන්න",
      "subtitle": "පවර නොකළ සහ පවරූ කාර්ය පවරීම් කළමනාකරණය කරන්න.",
      "unassignedTab": "පවර නොකළ කාර්ය",
      "assignedTab": "පවරූ කාර්ය",
      "reallocationTab": "නැවත පවරීම් ඉල්ලීම්",
      "reasonToRequestReallocation": "නැවත පවරීම ඉල්ලීමට හේතුව",
      "reallocationRequestedBy": "නැවත පවරීම ඉල්ලූ නිලධාරී",
      "reallocationRequestedAt": "නැවත පවරීම ඉල්ලූ වේලාව",
      "allocationModeLabel": "පවරීම් ක්‍රමය",
      "manualAllocation": "හස්තීය පවරීම",
      "roundRobinAllocation": "චක්‍රීය පැවරීම",
      "configureAssignment": "අනුයෝජනය වින්‍යාස කරන්න",
      "counsel": "නීතිඥ",
      "counselRequired": "නීතිඥ අවශ්‍යය.",
      "stateAttorney": "රාජ්‍ය නීතිඥ",
      "stateAttorneyRequired": "රාජ්‍ය නීතිඥ අවශ්‍යය.",
      "selectUserRequired": "පරිශීලකයා තෝරා ගැනීම අවශ්‍යය.",
      "supervisorRequired": "අධීක්ෂක අවශ්‍යය.",
      "userTaskIdRequired": "පරිශීලක කාර්ය id අවශ්‍යය.",
      "assignmentFailed": "පවරීම අසාර්ථක විය.",
      "assignmentSuccess": "පවරීම සාර්ථකව සුරකින ලදී.",
      "cancelAssignmentTitle": "පරිශීලක පවරීම අවලංගු කරන්න",
      "cancelAssignmentMessage": "අවලංගු කිරීමට අවශ්‍යද? සුරකි නොමැති වෙනස්කම් නැති වේ.",
      "noUsersFound": "පරිශීලකයින් හමු නොවීය",
      "selectToReassign": "නැවත පවරීමට තෝරන්න",
      "selectAllFiltered": "පෙරහන් කළ සියල්ල තෝරන්න",
      "selectToReassignRow": "{{ref}} නැවත පවරීමට තෝරන්න",
      "reassignNow": "දැන් නැවත පවරන්න",
      "reassignLater": "පසුව නැවත පවරන්න",
      "reassignNowInfo": "තෝරාගත් නඩු(ය) නැවත පවරීමට නීතිඥ, අධීක්ෂක සහ රාජ්‍ය නීතිඥ තෝරන්න.",
      "reassignNowConfirmTitle": "නැවත පැවරීම තහවුරු කරන්න",
      "reassignNowConfirmIntro": "තෝරාගත් නඩු {{count}} සඳහා, පහත පරිශීලකයින් තෝරාගෙන ඇත:",
      "reassignNowConfirmCounselLine": "1. නීතිඥ - {{name}}",
      "reassignNowConfirmSupervisorLine": "2. අධීක්ෂක - {{name}}",
      "reassignNowConfirmStateAttorneyLine": "3. රාජ්‍ය නීතිඥ - {{name}}",
      "reassignNowConfirmProceed": "ඔබ තහවුරු කළ පසු, තෝරාගත් නඩු {{count}} මෙම පරිශීලකයින්ට පවරනු ඇත. ඉදිරියට යාමට අවශ්‍ය බව ඔබට විශ්වාසද?",
      "reassignLaterInfo": "පසුව නැවත පවරීම තෝරාගැනීමෙන්, තහවුරු කිරීමෙන් පසු තෝරාගත් නඩු(ය) වත්මන් ඒකාබද්ධ/පවරන ලද නිලධාරියාගෙන් ඉවත් වේ. ඉන්පසු, මෙම නඩු 'නොපවරන ලද කාර්ය' ටැබය යටතේ ඒකාබද්ධ-පොරොත්තු නඩු ලෙස දිස්වනු ඇත.",
      "bulkReassignSuccess": "තෝරාගත් නඩු(ය) සාර්ථකව නැවත පවරන ලදී.",
      "bulkReassignFailed": "සමූහ නැවත පැවරීම අසාර්ථක විය.",
      "reassignNowConfirmTitle": "නැවත පැවරීම තහවුරු කරන්න",
      "reassignNowConfirmIntro": "තෝරාගත් නඩු {{count}} සඳහා පහත පරිශීලකයන් තෝරාගෙන ඇත:",
      "reassignNowConfirmOutro": "තහවුරු කළ පසු, තෝරාගත් නඩු {{count}} මෙම පරිශීලකයන්ට පවරනු ලැබේ. ඉදිරියට යාමට ඔබට විශ්වාසද?",
      "selectCasesToReassign": "නැවත පවරීමට අවම වශයෙන් නඩුවක් තෝරන්න.",
      "mixedCategoryReassignError": "තෝරාගත් නඩු එකම ගොනු කාණ්ඩය සහ උප ගොනු කාණ්ඩය බෙදාගත යුතුය."
    },
    "escalation": {
      "breadcrumb": "ඉහළ නැංවූ කාර්ය",
      "breadcrumbAssigned": "ඉහළ නැංවූ කාර්ය — පවරන ලද කාර්ය",
      "breadcrumbUnassigned": "ඉහළ නැංවූ කාර්ය — නොපවරන ලද කාර්ය",
      "title": "ඉහළ නැංවූ කාර්ය",
      "subtitle": "නැවත පැවරීම පොරොත්තුවෙන් ඇති ඉහළ නැංවූ කාර්ය සහ ඉහළ නැංවීමෙන් පසු දැනටමත් පවරා ඇති කාර්ය සමාලෝචනය කරන්න.",
      "unassignedTab": "නොපවරන ලද කාර්ය",
      "assignedTab": "පවරන ලද කාර්ය",
      "escalatedAt": "ඉහළ නැංවූ වේලාව"
    },
    "managementAssistant": {
      "breadcrumb": "නඩු විස්තර",
      "title": "නඩු විස්තර",
      "tableTitle": "කාර්ය සහ නඩු විස්තර",
      "tabActive": "සක්‍රිය කාර්ය සහ නඩු",
      "tabCreated": "සාදන ලද නඩු ඉල්ලීම්",
      "tabCompleted": "සම්පූර්ණ කළ කාර්ය සහ නඩු",
      "createdAt": "සාදන ලද දිනය/වේලාව",
      "loadFailed": "නඩු විස්තර පූරණය කළ නොහැක."
    },
    "details": {
      "breadcrumb": "කාර්ය/නඩු විස්තර",
      "title": "කාර්ය/නඩු විස්තර",
      "loading": "කාර්ය විස්තර පූරණය වෙමින්…",
      "caseDetailsLoadFailed": "නඩු විස්තර පූරණය කළ නොහැක. කරුණාකර පසුව නැවත උත්සාහ කරන්න.",
      "coverNotePdfFailed": "සාරාංශ සටහන PDF පූරණය කළ නොහැක.",
      "startMissingIds": "ආරම්භ කළ නොහැක: නඩු ඉල්ලීම් id හෝ පරිශීලක කාර්ය id අස්ථානගත වී ඇත.",
      "startFailed": "ආරම්භ කිරීම අසාර්ථක විය.",
      "startSuccess": "කාර්ය ආරම්භ කරන ලදී.",
      "closureValidateFailed": "වසා දැමීමේ ක්‍රියාව සත්‍යාපනය කළ නොහැක.",
      "fileReferenceNumber": "ගොනු යොමු අංකය",
      "currentStage": "වත්මන් අදියර",
      "physicalFileCustody": "භෞතික ගොනු භාරකාරත්වය",
      "linkedFileRef": "සම්බන්ධ ගොනු යොමු අංකය",
      "workflowProgress": "වැඩ පැවරුම් ප්‍රගතිය",
      "legendCompleted": "සම්පූර්ණ",
      "legendCurrent": "වත්මන්",
      "legendPending": "පොරොත්තු",
      "tabCaseDetails": "නඩු විස්තර",
      "tabCaseUpdate": "නඩු යාවත්කාලීනය",
      "tabDocuments": "ලේඛන",
      "tabCommunications": "සන්නිවේදන",
      "tabCaseMinutes": "නඩු විනාඩි",
      "tabDraftLetter": "කෙටුම්පත් ලිපිය",
      "tabSubTasks": "උප කාර්ය",
      "tabFileMovementLog": "ගොනු ගමනාගමන ලොගය",
      "tabInvolvement": "සම්බන්ධතාව",
      "tabAuditLog": "විගණන ලොගය",
      "fileMovementTitle": "ගොනු ගමනාගමන ලොග විස්තර",
      "dateTime": "දිනය සහ වේලාව",
      "event": "සිදුවීම",
      "fileCustody": "ගොනු භාරකාරත්වය",
      "qrCheckIn": "QR ඇතුල් වීම",
      "qrCheckOut": "QR පිටවීම",
      "noFileMovement": "මෙම නඩු ඉල්ලීම සඳහා ගොනු ගමනාගමන ක්‍රියාකාරකම් නොමැත.",
      "loadingQr": "QR පූරණය වෙමින්…",
      "qrUnavailable": "QR code නොමැත",
      "qrAlt": "නඩු ඉල්ලීම සාරාංශ සටහන QR code",
      "viewCoverNote": "සාරාංශ සටහන බලන්න",
      "preparing": "සූදානම් වෙමින්…",
      "printCoverNote": "සාරාංශ සටහන මුද්‍රණය කරන්න",
      "workflowActions": "වැඩ පැවරුම් ක්‍රියා",
      "reviewForwardHint": "මෙම සමාලෝචන කාර්යය වෙනත් නිලධාරියෙකු වෙත යැවීමට ඉදිරියට යවන්න භාවිතා කරන්න.",
      "completeHint": "සම්පූර්ණ කිරීමට පෙර විකල්ප ක්‍රියා තෝරන්න. මෙම කාර්ය/නඩුව සම්පූර්ණ කිරීමට සම්පූර්ණ කරන්න ක්ලික් කරන්න.",
      "submitHint": "ඉදිරිපත් කිරීමට පෙර විකල්ප ක්‍රියා තෝරන්න. මෙම කාර්ය/නඩුව සම්පූර්ණ කර ඉදිරියට යැවීමට {{submitLabel}} ක්ලික් කරන්න.",
      "forward": "ඉදිරියට යවන්න",
      "revert": "පෙර තත්ත්වයට",
      "reject": "ප්‍රතික්ෂේප කරන්න",
      "closure": "වැසීම",
      "complete": "සම්පූර්ණ කරන්න",
      "submit": "ඉදිරිපත් කරන්න",
      "checking": "පරීක්ෂා කරමින්…",
      "starting": "ආරම්භ කරමින්…",
      "start": "ආරම්භ කරන්න",
      "started": "ආරම්භ කර ඇත",
      "blockingSubTasks": "මෙම වැඩ පැවරුම් අදියරේ පොරොත්තුවෙන් පවතින උප කාර්ය ඇත. ඉදිරියට යාමට ඒවා සම්පූර්ණ කරන්න.",
      "closureAlreadyClicked": "මෙම කාර්යය සඳහා වසා දැමීමේ අනුමත කරන්නා දැනටමත් තෝරා ඇත.",
      "statusInProgress": "ප්‍රගතියේ",
      "custodyPendingDocumentArrival": "ලේඛනය පැමිණීම පොරොත්තුවෙන්",
      "communications": {
        "loading": "සන්නිවේදන පූරණය වෙමින්…",
        "loadFailed": "සන්නිවේදන පූරණය කිරීම අසාර්ථක විය.",
        "invalidCaseRequest": "නඩු ඉල්ලීම් හැඳුනුම්පත අවලංගු හෝ නැත.",
        "addComment": "අදහසක් එක් කරන්න",
        "addCommentPlaceholder": "අදහසක් එක් කරන්න...",
        "adding": "එක් කරමින්…",
        "addSuccess": "අදහස සාර්ථකව එක් කරන ලදී.",
        "addFailed": "අදහස එක් කළ නොහැක.",
        "commentRequired": "කරුණාකර අදහසක් ඇතුළත් කරන්න.",
        "commentTooLong": "අදහස අක්ෂර {{max}} ක් හෝ ඊට අඩු විය යුතුය.",
        "commentInvalid": "අදහසේ අවලංගු අක්ෂර අඩංගු වේ.",
        "characters": "අක්ෂර",
        "visibleToExternal": "බාහිර ආයතනයට දෘශ්‍යමාන",
        "cancelTitle": "වෙනස්කම් අවලංගු කරන්න",
        "cancelMessage": "අවලංගු කිරීමට අවශ්‍යද? සුරකි නොකළ වෙනස්කම් නැති වේ.",
        "onHold": "රඳවා තබන්න",
        "resume": "නැවත ආරම්භ කරන්න",
        "holdSuccess": "කාර්යය රඳවා තැබිණි.",
        "holdFailed": "කාර්යය රඳවා තැබීමට නොහැක.",
        "resumeSuccess": "කාර්යය නැවත ආරම්භ කරන ලදී.",
        "resumeFailed": "කාර්යය නැවත ආරම්භ කළ නොහැක.",
        "visibleExternalWarningTitle": "බාහිර ආයතනයට දෘශ්‍යමාන අවශ්‍යය",
        "visibleExternalWarningMessage": "කාර්යය රඳවා තැබීමේ හේතුව බාහිර ආයතනය දැනුවිදින ලෙස 'බාහිර ආයතනයට දෘශ්‍යමාන' සලකුණු කර අදහස එක් කරන්න.",
        "rtiExtension": {
          "requestButton": "Request Extension",
          "resumeButton": "Resume Upon Extension Response",
          "modalTitle": "Request for an Extension",
          "reasonLabel": "Reason for Requesting an Extension",
          "reasonPlaceholder": "Enter the reason for requesting an extension…",
          "reasonRequired": "Reason for Requesting an Extension is required.",
          "reasonTooLong": "Reason must be {{max}} characters or fewer.",
          "confirmTitle": "Submit Extension Request",
          "confirmMessage": "Are you sure you want to submit this extension request? The case will be placed on hold until you resume upon receiving a response from the external agency.",
          "requestSuccess": "Extension request submitted successfully.",
          "requestFailed": "Could not submit extension request."
        }
      }
    },
    "modals": {
      "forward": {
        "title": "කාර්යය ඉදිරියට යවන්න",
        "physicalFileMovement": "භෞතික ගොනු ගමනාගමනය අවශ්‍යය",
        "selectDocumentMover": "ලේඛන ගෙනයන්නා තෝරන්න",
        "selectDocumentMoverRequired": "ලේඛන ගෙනයන්නා තෝරා ගැනීම අවශ්‍යය.",
        "forwardTask": "කාර්යය ඉදිරියට යවන්න",
        "forwarding": "ඉදිරියට යවමින්…",
        "forwardSuccess": "කාර්යය සාර්ථකව ඉදිරියට යවන ලදී.",
        "forwardFailed": "ඉදිරියට යැවීම අසාර්ථක විය.",
        "loadUsersFailed": "පරිශීලකයින් පූරණය කළ නොහැක.",
        "loadMoversFailed": "ලේඛන ගෙනයන්නන් පූරණය කළ නොහැක.",
        "discardTitle": "වෙනස්කම් ඉවතලන්නද?",
        "discardMessage": "අවලංගු කළහොත් ඔබේ වෙනස්කම් නැති වේ."
      },
      "revert": {
        "title": "කාර්යය ආපසු හරවන්න",
        "revertToStage": "ආපසු හැරවීමේ අදියර",
        "selectStage": "අදියර තෝරන්න",
        "selectUser": "පරිශීලකයා තෝරන්න",
        "reallocationReason": "නැවත පවරීම ඉල්ලීමට හේතුව",
        "reallocationReasonPlaceholder": "නැවත පවරීම ඉල්ලීමට හේතුව ඇතුළත් කරන්න",
        "reallocationReasonRequired": "නැවත පවරීම ඉල්ලීමට හේතුව අවශ්‍යය.",
        "reallocationReasonTooLong": "හේතුව අක්ෂර {{max}} ක් දක්වා පමණක් විය හැක.",
        "revertTask": "කාර්යය ආපසු හරවන්න",
        "reverting": "ආපසු හරමින්…",
        "revertSuccess": "කාර්යය සාර්ථකව ආපසු හරවන ලදී.",
        "revertFailed": "ආපසු හැරවීම අසාර්ථක විය.",
        "stageRequired": "ආපසු හැරවීමේ අදියර අවශ්‍යය.",
        "userRequired": "පරිශීලකයා තෝරා ගැනීම අවශ්‍යය.",
        "userTaskRequired": "පරිශීලක කාර්ය id අවශ්‍යය.",
        "loadStagesFailed": "පූරණය කළ නොහැක",
        "loadUsersFailed": "පූරණය කළ නොහැක",
        "loadMoversFailed": "පූරණය කළ නොහැක",
        "subtaskConfirmTitle": "උප කාර්ය තවමත් ප්‍රගතියේ",
        "subtaskConfirmMessage": "එක් හෝ වැඩි උප කාර්ය තවමත් ප්‍රගතියේ ඇත. ආපසු හැරවීමෙන් ඒවාට බලපෑමක් විය හැක. ඉදිරියට යන්නද?",
        "subtaskWarning": "එක් හෝ වැඩි උප කාර්ය තවමත් ප්‍රගතියේ ඇත. ආපසු හැරවීමට පෙර තහවුරු කරන්න."
      }
    },
    "createCaseRequest": {
      "breadcrumb": "නඩු ඉල්ලීමක් සාදන්න",
      "title": "නඩු ඉල්ලීමක් සාදන්න",
      "subtitle": "නව නඩු ඉල්ලීමක් ඉදිරිපත් කිරීමට පහත බහු-පියවර පෝරමය සම්පූර්ණ කරන්න.",
      "stepLabel": "පියවර {{num}}",
      "stepCaseOverview": "නඩු දළ විශ්ලේෂණය",
      "stepChildGuardian": "ළමයා සහ භාරකරු",
      "stepIncidentEvidence": "සිද්ධිය සහ සාක්ෂි",
      "stepSubmissionDelivery": "ඉදිරිපත් කිරීම සහ බෙදාහැරීම",
      "stepUploadDocuments": "ලේඛන උඩුගත කරන්න",
      "step01Title": "පියවර 01 – නඩු දළ විශ්ලේෂණය",
      "step02Title": "පියවර 02 – ළමයා සහ භාරකරු තොරතුරු",
      "step03Title": "පියවර 03 – සිද්ධිය සහ සාක්ෂි",
      "step04Title": "පියවර 04 – ඉදිරිපත් කිරීම සහ භෞතික ගොනු බෙදාහැරීම",
      "step05Title": "පියවර 05 – ලේඛන උඩුගත කරන්න",
      "requestDetails": "ඉල්ලීම් විස්තර",
      "requestCategory": "ඉල්ලීම් කාණ්ඩය",
      "subject": "මාතෘකාව",
      "subjectPlaceholder": "නඩුවේ කෙටි මාතෘකාවක් ඇතුළත් කරන්න",
      "description": "විස්තරය",
      "descriptionPlaceholder": "ඉල්ලීමේ විස්තරාත්මක විස්තරයක් ඇතුළත් කරන්න",
      "caseIntakeDetails": "නඩු භාරගැනීමේ විස්තර",
      "caseSource": "නඩු මූලාශ්‍රය",
      "selectCaseSource": "නඩු මූලාශ්‍රය තෝරන්න",
      "province": "පළාත",
      "selectProvince": "පළාත තෝරන්න",
      "childDetails": "ළමා විස්තර",
      "childName": "ළමයාගේ නම",
      "childNamePlaceholder": "ළමයාගේ සම්පූර්ණ නම",
      "childDob": "ළමයාගේ උපන් දිනය",
      "gender": "ස්ත්‍රී පුරුෂ භාවය",
      "selectGender": "ස්ත්‍රී පුරුෂ භාවය තෝරන්න",
      "guardianName": "භාරකරුගේ නම",
      "guardianNamePlaceholder": "මාපියාගේ හෝ නෛතික භාරකරුගේ සම්පූර්ණ නම",
      "incidentDetails": "සිද්ධි විස්තර",
      "incidentDate": "සිද්ධිය සිදු වූ දිනය",
      "incidentLocation": "සිද්ධිය සිදු වූ ස්ථානය",
      "incidentLocationPlaceholder": "සිද්ධිය සිදු වූ ස්ථානය විස්තර කරන්න",
      "relationshipConfidentiality": "සම්බන්ධතාව සහ රහස්‍යභාවය",
      "relationshipToChild": "ළමයා සමඟ සම්බන්ධතාව",
      "selectRelationship": "සම්බන්ධතාව තෝරන්න",
      "confidentiality": "රහස්‍යභාවය",
      "markConfidential": "මෙම ඉල්ලීම රහස්‍ය ලෙස සලකුණු කරන්න",
      "deliveryMethodSection": "භෞතික ගොනුව සඳහා බෙදාහැරීමේ ක්‍රමය තෝරන්න",
      "deliveryMethod": "බෙදාහැරීමේ ක්‍රමය",
      "upload": "උඩුගත කරන්න",
      "dragDrop": "ගොනු මෙතැනට ඇද දමන්න",
      "or": "හෝ",
      "browseFiles": "ගොනු බ්‍රවුස් කරන්න",
      "dummyUploadNote": "මෙම නිමැවුමේ ආදර්ශ උඩුගත ලැයිස්තුවකි.",
      "submitRequest": "ඉල්ලීම ඉදිරිපත් කරන්න"
    }
  },
  "caseScenarios": {
    "breadcrumb": "නඩු අවස්ථා",
    "title": "නඩු අවස්ථා",
    "loading": "නඩු අවස්ථා පූරණය වෙමින්…",
    "none": "PDF සහිත සක්‍රිය නඩු අවස්ථා නොමැත.",
    "loadFailed": "නඩු අවස්ථා පූරණය කළ නොහැක.",
    "viewPdf": "PDF බලන්න",
    "pdfTitle": "නඩු අවස්ථා ලේඛනය",
    "loadingPdf": "PDF පූරණය වෙමින්…",
    "pdfLoadFailed": "නඩු අවස්ථා PDF පූරණය කළ නොහැක."
  },
  "notifications": {
    "breadcrumb": "දැනුම්දීම්",
    "title": "දැනුම්දීම්",
    "markAllRead": "සියල්ල කියවූ ලෙස සලකුණු කරන්න",
    "marking": "සලකුණු කරමින්…",
    "allTab": "සියලු දැනුම්දීම් ({{count}})",
    "unreadTab": "නොකියවූ ({{count}})",
    "loading": "දැනුම්දීම් පූරණය වෙමින්…",
    "noUnread": "නොකියවූ දැනුම්දීම් නොමැත.",
    "none": "දැනුම්දීම් නොමැත.",
    "loadFailed": "දැනුම්දීම් පූරණය කළ නොහැක.",
    "markAllFailed": "දැනුම්දීම් කියවූ ලෙස සලකුණු කළ නොහැක.",
    "markReadFailed": "දැනුම්දීම කියවූ ලෙස සලකුණු කළ නොහැක.",
    "defaultTitle": "දැනුම්දීම",
    "caseRef": "නඩු යොමුව",
    "showingRange": "දැනුම්දීම {{total}} න් {{start}} සිට {{end}} දක්වා පෙන්වයි",
    "showingRange_plural": "දැනුම්දීම් {{total}} න් {{start}} සිට {{end}} දක්වා පෙන්වයි",
    "templates": {
      "caseAssignment": {
        "title": "නඩු පවරීම",
        "body": "කාර්යයක් හෝ නඩුවක් ({{ref}}) ඔබේ කාර්ය ප්‍රවාහ අදියර වෙත පවරා ඇත. විස්තර සමාලෝචනය කර අවශ්‍ය ක්‍රියාමාර්ග ගන්න."
      }
    }
  },
  "dashboards": {
    "breadcrumb": "උපකරණ පුවරු සහ වාර්තාකරණය",
    "title": "උපකරණ පුවරු",
    "subtitle": "භූමිකා මත පදනම් වූ වැඩ බර, SLA සංඥා සහ බාධක දර්ශනය (ආදර්ශ දත්ත).",
    "reportingPeriod": "වාර්තා කාලය",
    "last7Days": "පසුගිය දින 7",
    "last30Days": "පසුගිය දින 30",
    "last90Days": "පසුගිය දින 90",
    "savedPreferences": "සුරකින ලද මනාප",
    "preferencesHint": "වෙනස් කළ පෙරහන් ඔබේ සැසිය සඳහා පවතී; API ලබා ගත හැකි විට ස්වයංක්‍රීය නැවුම් කිරීම සම්බන්ධ කළ හැක (FR61).",
    "openTasks": "විවෘත කාර්ය",
    "openTasksHint": "පවරන ලද සියලු වැඩ පිළිවෙල් හරහා",
    "slaAtRisk": "SLA අවදානමේ",
    "slaAtRiskHint": "TTR කවුළුව තුළ",
    "overdue": "කල් ඉකුත්",
    "overdueHint": "TTE ඉක්මවා — උසස් කිරීම් සමාලෝචනය කරන්න",
    "avgStageDuration": "සාම. අදියර කාලය",
    "avgStageDurationHint": "ගෙවී ගිය දින 30",
    "workloadGraphTitle": "වැඩ පිළිවෙල අනුව වැඩ බර (චිත්‍රක සාරාංශය)",
    "activeCount": "{{count}} සක්‍රිය",
    "workloadTableTitle": "වැඩ බර විස්තර (වගුගත)",
    "workflowColumn": "වැඩ පිළිවෙල",
    "activeTasksColumn": "සක්‍රිය කාර්ය",
    "workflows": {
      "standardProsecutionAdvice": "සම්මත අධියෝගනය උපදෙස්",
      "civilReviewContract": "සිවිල් සමාලෝචනය — ගිවිසුම",
      "advisoryHumanRights": "උපදෙස් — මානව හිමිකම්"
    }
  },
  "allocationDashboard": {
    "from": "සිට",
    "to": "දක්වා",
    "apply": "යොදන්න",
    "showingRange": "පෙන්වමින්: {{from}} – {{to}}",
    "caseTrackingPanel": "නඩු නිරීක්ෂණ පැනලය",
    "casesNoun": "නඩු",
    "colFileRef": "ගොනු යොමු අංකය",
    "colFileCategory": "ගොනු වර්ගය",
    "colSubFileCategory": "උප ගොනු වර්ගය",
    "colSubmittedAgency": "ඉදිරිපත් කළ ආයතනය",
    "colSubmittedAt": "ඉදිරිපත් කළ දිනය",
    "colWorkflowStage": "කාර්ය ප්‍රවාහ අදියර",
    "colAllocationOfficer": "වෙන් කිරීමේ නිලධාරියා",
    "colAssignedOfficer": "පැවරූ නිලධාරියා",
    "colSupervisor": "අධීක්ෂක",
    "colStateAttorney": "රාජ්‍ය නීතිඥ",
    "colTaskStatus": "කාර්ය තත්ත්වය",
    "colUrgencyLevel": "හදිසි මට්ටම",
    "colActions": "ක්‍රියා",
    "viewCaseDetails": "කාර්ය/නඩු විස්තර බලන්න",
    "viewCaseTimeline": "නඩු කාලරේඛාව බලන්න",
    "auditModalTitle": "නඩු කාලරේඛාව",
    "auditColDateTime": "දිනය සහ වේලාව",
    "auditColActivityBy": "ක්‍රියාව සිදුකළේ",
    "auditColAction": "ක්‍රියාව",
    "noAuditLogs": "විගණන සටහන් කිසිවක් හමු නොවීය."
  },
  "sgDashboard": {
    "breadcrumb": "උපකරණ පුවරුව",
    "title": "මාතෘකාව",
    "subtitle": "උප මාතෘකාව",
    "charts": {
      "urgency": "හදිසි මට්ටම අනුව නඩු",
      "urgencyTip": "{{from}} සිට {{to}} දක්වා කාලය තුළ, හදිසි මට්ටම අනුව ඉදිරිපත් කළ සියලු නඩු.",
      "status": "තත්ත්වය අනුව නඩු",
      "statusTip": "{{from}} සිට {{to}} දක්වා කාලය තුළ, වර්තමාන කාර්ය ප්‍රවාහ අදියරේදී, තත්ත්වය අනුව ඉදිරිපත් කළ සියලු නඩු.",
      "category": "ගොනු වර්ගය සහ උප ගොනු වර්ගය අනුව නඩු",
      "categoryTip": "{{from}} සිට {{to}} දක්වා කාලය තුළ, ගොනු වර්ගය සහ උප ගොනු වර්ගය අනුව ඉදිරිපත් කළ සියලු නඩු."
    },
    "kpis": {
      "submitted": "ඉදිරිපත් කළ",
      "submittedTip": "{{from}} සිට {{to}} දක්වා කාලය තුළ, Extranet සහ Intranet ද්වාර හරහා ඉදිරිපත් කරන ලද මුළු නඩු ගණන.",
      "pendingAssignment": "පැවරීම අපේක්ෂාවෙන්",
      "pendingAssignmentTip": "ඉදිරිපත් කළ සියලු නඩු අතුරින්, {{from}} සිට {{to}} දක්වා කාලය තුළ, ආරම්භක වෙන් කිරීම අපේක්ෂාවෙන් සිටින සහ නැවත වෙන් කිරීමට ඉල්ලා ඇති මුළු නඩු ගණන.",
      "assignedInProgress": "පවරා ඇති සහ ක්‍රියාත්මක වෙමින්",
      "assignedInProgressTip": "ඉදිරිපත් කළ සියලු නඩු අතුරින්, {{from}} සිට {{to}} දක්වා කාලය තුළ, දැනටමත් පවරා ඇති සහ වර්තමානයේ ක්‍රියාත්මක වෙමින් පවතින මුළු නඩු ගණන.",
      "highUrgency": "ඉහළ හදිසි මට්ටම",
      "highUrgencyTip": "ඉදිරිපත් කළ සියලු නඩු අතුරින්, {{from}} සිට {{to}} දක්වා කාලය තුළ, හදිසි මට්ටම = ඉහළ ලෙස සලකුණු කර ඇති මුළු නඩු ගණන.",
      "escalated": "උසස් කරන ලද",
      "escalatedTip": "ඉදිරිපත් කළ සියලු නඩු අතුරින්, {{from}} සිට {{to}} දක්වා කාලය තුළ, වර්තමාන කාර්ය ප්‍රවාහ අදියරේදී උසස් කර ඇති මුළු නඩු ගණන.",
      "kpiCompliant": "KPI අනුකූල",
      "kpiCompliantTip": "ඉදිරිපත් කළ සියලු නඩු අතුරින්, {{from}} සිට {{to}} දක්වා කාලය තුළ, වර්තමාන කාර්ය ප්‍රවාහ අදියරේදී KPI-අනුකූලව පවතින මුළු නඩු ගණන.",
      "completed": "සම්පූර්ණ කළ",
      "completedTip": "ඉදිරිපත් කළ සියලු නඩු අතුරින්, {{from}} සිට {{to}} දක්වා කාලය තුළ, සම්පූර්ණ කර ඇති මුළු නඩු ගණන."
    }
  },
  "operationalDashboard": {
    "breadcrumb": "උපකරණ පුවරුව",
    "title": "මාතෘකාව",
    "subtitle": "උප මාතෘකාව",
    "charts": {
      "urgency": "හදිසි මට්ටම අනුව නඩු",
      "urgencyTip": "{{from}} සිට {{to}} දක්වා කාලය තුළ, හදිසි මට්ටම අනුව මට පවරා ඇති සියලු නඩු.",
      "status": "තත්ත්වය අනුව නඩු",
      "statusTip": "{{from}} සිට {{to}} දක්වා කාලය තුළ, වර්තමාන කාර්ය ප්‍රවාහ අදියරේදී, තත්ත්වය අනුව මට පවරා ඇති සියලු නඩු.",
      "category": "ගොනු වර්ගය සහ උප ගොනු වර්ගය අනුව නඩු",
      "categoryTip": "{{from}} සිට {{to}} දක්වා කාලය තුළ, ගොනු වර්ගය සහ උප ගොනු වර්ගය අනුව මට පවරා ඇති සියලු නඩු."
    },
    "kpis": {
      "assignedInProgress": "පවරා ඇති සහ ක්‍රියාත්මක වෙමින්",
      "assignedInProgressTip": "ඉදිරිපත් කළ සියලු නඩු අතුරින්, {{from}} සිට {{to}} දක්වා කාලය තුළ, දැනටමත් මට පවරා ඇති මුළු නඩු ගණන.",
      "highUrgency": "ඉහළ හදිසි මට්ටම",
      "highUrgencyTip": "මට පවරා ඇති සියලු නඩු අතුරින්, {{from}} සිට {{to}} දක්වා කාලය තුළ, හදිසි මට්ටම = ඉහළ ලෙස සලකුණු කර ඇති මුළු නඩු ගණන.",
      "escalated": "උසස් කරන ලද",
      "escalatedTip": "මට පවරා ඇති සියලු නඩු අතුරින්, {{from}} සිට {{to}} දක්වා කාලය තුළ, වර්තමාන කාර්ය ප්‍රවාහ අදියරේදී උසස් කර ඇති මුළු නඩු ගණන.",
      "kpiCompliant": "KPI අනුකූල",
      "kpiCompliantTip": "මට පවරා ඇති සියලු නඩු අතුරින්, {{from}} සිට {{to}} දක්වා කාලය තුළ, වර්තමාන කාර්ය ප්‍රවාහ අදියරේදී KPI-අනුකූලව පවතින මුළු නඩු ගණන.",
      "completed": "සම්පූර්ණ කළ",
      "completedTip": "මට පවරා ඇති සියලු නඩු අතුරින්, {{from}} සිට {{to}} දක්වා කාලය තුළ, සම්පූර්ණ කර ඇති මුළු නඩු ගණන."
    }
  },
  "reports": {
    "breadcrumb": "වාර්තා",
    "previewTitle": "වාර්තා පෙරදසුන",
    "records": "පටිගත",
    "reset": "යළි සකසන්න",
    "search": "සොයන්න",
    "generateReport": "වාර්තාව ජනනය කරන්න",
    "generating": "ජනනය වෙමින්…",
    "generateSuccess": "වාර්තාව සාර්ථකව ජනනය විය.",
    "generateFailed": "වාර්තාව ජනනය කළ නොහැකි විය.",
    "exportFailed": "වාර්තාව අපනයනය කළ නොහැකි විය.",
    "searchFailed": "වාර්තා දත්ත පූරණය කළ නොහැකි විය.",
    "dateValidation": {
      "fromFuture": "සිට දිනය අනාගතයේ විය නොහැක.",
      "toFuture": "දක්වා දිනය අනාගතයේ විය නොහැක.",
      "fromAfterTo": "සිට දිනය දක්වා දිනයට පසුව විය නොහැක."
    },
    "exportOptions": "අපනයන විකල්ප",
    "exportAs": "අපනයනය",
    "exportAsPdf": "PDF ලෙස අපනයනය",
    "exportAsExcel": "Excel ලෙස අපනයනය",
    "exportFormatPdf": "PDF",
    "exportFormatExcel": "Excel",
    "exportStub": "වාර්තා API සම්බන්ධ වූ පසු {{format}} අපනයනය ලබා ගත හැක.",
    "filters": {
      "userRoles": "පරිශීලක භූමිකා(ය)",
      "selectUserRoles": "පරිශීලක භූමිකා(ය) තෝරන්න",
      "userNames": "පරිශීලක නම(ය)",
      "selectUserNames": "පරිශීලක නම(ය) තෝරන්න",
      "fileCategories": "ගොනු කාණ්ඩ(ය)",
      "selectFileCategories": "ගොනු කාණ්ඩ(ය) තෝරන්න",
      "subFileCategories": "උප ගොනු කාණ්ඩ(ය)",
      "selectSubFileCategories": "උප ගොනු කාණ්ඩ(ය) තෝරන්න",
      "divisionsUnits": "අංශ(ය) / ඒකක(ය)",
      "selectDivisionsUnits": "අංශ(ය) / ඒකක(ය) තෝරන්න",
      "submittedAgency": "ඉදිරිපත් කළ ආයතනය",
      "selectAgency": "ආයතනය තෝරන්න",
      "taskStatus": "කාර්ය තත්ත්වය",
      "selectStatus": "තත්ත්වය තෝරන්න",
      "urgencyLevel": "අත්‍යවශ්‍යතා මට්ටම",
      "selectUrgencyLevel": "අත්‍යවශ්‍යතා මට්ටම තෝරන්න",
      "workflowStage": "වැඩ පිළිවෙල අදියර",
      "selectStage": "අදියර තෝරන්න",
      "workflowStages": "වැඩ පිළිවෙල අදියර(ය)",
      "selectWorkflowStages": "වැඩ පිළිවෙල අදියර(ය) තෝරන්න",
      "all": "සියල්ල",
      "workflowTemplateNames": "වැඩ පිළිවෙල අච්චු නම(ය)",
      "selectWorkflowTemplates": "වැඩ පිළිවෙල අච්චු(ය) තෝරන්න",
      "allocationOfficer": "අනුයෝජන නිලධාරී(ය)",
      "selectAllocationOfficer": "අනුයෝජන නිලධාරී(ය) තෝරන්න",
      "assignedOfficer": "පවරන ලද නිලධාරී",
      "selectAssignedOfficer": "පවරන ලද නිලධාරී තෝරන්න",
      "supervisor": "අධීක්ෂක",
      "selectSupervisor": "අධීක්ෂක තෝරන්න",
      "workflowTemplateStatus": "වැඩ පිළිවෙල අච්චු තත්ත්ව(ය)",
      "selectWorkflowTemplateStatus": "වැඩ පිළිවෙල අච්චු තත්ත්ව(ය) තෝරන්න",
      "typeToSearch": "සොයන්න අවම වශයෙන් අක්ෂර 3ක් ටයිප් කරන්න",
      "clearSelection": "සියලු තේරීම් ඉවත් කරන්න",
      "from": "සිට",
      "to": "දක්වා"
    },
    "upr": {
      "title": "පරිශීලක කාර්ය සාධන වාර්තාව",
      "colUserName": "පරිශීලක නම",
      "colUserRoles": "පරිශීලක භූමිකා(ය)",
      "colDivisionUnit": "අංශය / ඒකකය",
      "colAssigned": "අනුයෝජිත",
      "colEscalated": "උසස් කළ",
      "colCompleted": "සම්පූර්ණ"
    },
    "ctr": {
      "title": "නඩු නිරීක්ෂණ වාර්තාව",
      "colFileRef": "ගොනු යොමු අංකය",
      "colFileCategory": "ගොනු කාණ්ඩය",
      "colSubFileCategory": "උප ගොනු කාණ්ඩය",
      "colSubmittedAgency": "ඉදිරිපත් කළ ආයතනය",
      "colSubmittedAt": "ඉදිරිපත් කළ වේලාව",
      "colWorkflowStage": "වැඩ පිළිවෙල අදියර",
      "colAllocationOfficer": "අනුයෝජන නිලධාරී",
      "colAssignedOfficer": "පවරන ලද නිලධාරී",
      "colSupervisor": "අධීක්ෂක",
      "colTaskStatus": "කාර්ය තත්ත්වය",
      "colUrgencyLevel": "අත්‍යවශ්‍යතා මට්ටම"
    },
    "wpr": {
      "title": "වැඩ පිළිවෙල කාර්ය සාධන වාර්තාව",
      "colWorkflowCode": "වැඩ පිළිවෙල කේතය",
      "colWorkflowTemplateStatus": "වැඩ පිළිවෙල අච්චු තත්ත්වය",
      "colWorkflowTemplateName": "වැඩ පිළිවෙල අච්චු නම",
      "colFileCategory": "ගොනු කාණ්ඩය",
      "colSubFileCategory": "උප ගොනු කාණ්ඩය",
      "colAllocationOfficer": "අනුයෝජන නිලධාරී",
      "colWorkflowStage": "වැඩ පිළිවෙල අදියර",
      "colCasesReceived": "ලැබුණු නඩු",
      "colCompleted": "සම්පූර්ණ",
      "colInProgress": "ප්‍රගතියේ",
      "colOverdue": "කල් ඉකුත්",
      "colEscalated": "උසස් කළ"
    }
  },
  "mailRoom": {
    "breadcrumb": "නඩු ඉදිරිපත් කිරීමේ ඉල්ලීම්",
    "title": "නඩු ඉදිරිපත් කිරීමේ ඉල්ලීම්",
    "loadFailed": "නඩු ඉදිරිපත් කිරීමේ ඉල්ලීම් පූරණය කළ නොහැක.",
    "tableTitle": "නඩු ඉදිරිපත් කිරීමේ ඉල්ලීම් විස්තර",
    "physicalFileStatus": "භෞතික ගොනු තත්ත්වය",
    "fileDeliveryMethod": "ගොනු බෙදාහැරීමේ ක්‍රමය",
    "fileMovementDateTime": "ගොනු ගමනාගමන දිනය සහ වේලාව",
    "physicalFileCustody": "භෞතික ගොනුවේ වර්තමාන භාරකාරත්වය",
    "viewCoverNote": "සාරාංශ සටහන බලන්න"
  },
  "recordRoom": {
    "breadcrumb": "සම්පූර්ණ කළ ගොනු",
    "title": "සම්පූර්ණ කළ ගොනු",
    "loadFailed": "සම්පූර්ණ කළ ගොනු පූරණය කළ නොහැක.",
    "tableTitle": "සම්පූර්ණ කළ ගොනු විස්තර",
    "caseCompletedAt": "නඩුව සම්පූර්ණ කළ වේලාව",
    "physicalFileStatus": "භෞතික ගොනු තත්ත්වය",
    "fileMovementDateTime": "ගොනු ගමනාගමන දිනය සහ වේලාව",
    "physicalFileCustody": "භෞතික ගොනුවේ වර්තමාන භාරකාරත්වය",
    "storageLocation": "ගබඩා ස්ථානය",
    "viewCoverNote": "සාරාංශ සටහන බලන්න",
    "coverNoteUnavailable": "සාරාංශ සටහන ලබා ගත නොහැක (නඩු ඉල්ලීම id නැත)",
    "updateStorageLocation": "ගබඩා ස්ථානය යාවත්කාලීන කරන්න"
  },
  "qrScanningLog": {
    "breadcrumb": "QR ස්කෑනिंग ලොගය",
    "title": "QR ස්කෑනिंग ලොගය",
    "tableTitle": "QR ස්කෑන් අවස්ථා විස්තර",
    "fileRef": "ගොනු අංකය",
    "fileCategory": "ගොනු කාණ්ඩය",
    "subFileCategory": "උප ගොනු කාණ්ඩය",
    "event": "සිදුවීම",
    "eventAt": "සිදුවීම් දිනය සහ වේලාව",
    "systemAutomated": "පද්ධතිය විසින් ස්වයංක්‍රිය",
    "viewResult": "ප්‍රති result බලන්න",
    "view": "දැක්ම",
    "caseRequestId": "නඩු ඉල්ලීම් ID",
    "checkedInBy": "ඇතුල් කළේ",
    "role": "භූමිකාව",
    "checkedInAt": "ඇතුල් කළ වේලාව",
    "destination": "ගමනාන්තය",
    "receiverName": "ලබන්නාගේ නම",
    "divisionUnit": "බෙදුම් / ඒකකය",
    "designation": "තනතුර",
    "proceedToScanQr": "QR ස්කෑන් කරන්න",
    "scanQrCode": "QR කේතය ස්කෑන් කරන්න",
    "scanInstruction": "භෞතික ගොනුවේ QR කේතය වෙත QR ස්කෑන් යන්ත්‍රය යොමු කර, භෞතික ගොනුව ලැබී ඇති බව සලකුණු කර පිළිගැනීම ලබා දෙන්න. QR ස්කෑන් යන්ත්‍රය USB කේබල් මගින් සම්බන්ධ වී ඇති බව සහතික කර ගන්න. QR ස්කෑන් කිරීම සාර්ථක වූ විට, ගොනු අංකය පහළින් දිස්වනු ඇත.",
    "scanInstructionDetail": "QR කේතය ස්කෑන් කිරීමේ රාමුව තුළ තබා භෞතික ගොනුව තහවුරු කර පිරිලැයි කිරීමේ ක්‍රියාවලිය ඉදිරියට ගෙන යන්න.",
    "scanPlaceholder": "QR ස්කෑන් පූර්ව දර්ශනය"
  },
  "workflow": {
    "management": "වැඩ පිළිවෙල කළමනාකරණය",
    "templates": {
      "breadcrumb": "වැඩ පිළිවෙල අච්චු",
      "title": "වැඩ පිළිවෙල අච්චු",
      "createNew": "+ නව වැඩ පිළිවෙල අච්චුවක් සාදන්න",
      "templateName": "වැඩ පිළිවෙල අච්චු නාමය",
      "templateNamePlaceholder": "වැඩ පිළිවෙල අච්චු නාමය ඇතුළත් කරන්න",
      "selectFileCategory": "ගොනු කාණ්ඩය තෝරන්න",
      "selectSubFileCategory": "උප ගොනු කාණ්ඩය තෝරන්න",
      "selectStatus": "තත්ත්වය තෝරන්න",
      "allocationOfficer": "අනුයෝජනය නිලධාරී",
      "selectAllocationOfficer": "අනුයෝජනය නිලධාරී තෝරන්න",
      "tableTitle": "වැඩ පිළිවෙල අච්චු විස්තර",
      "workflowCode": "වැඩ පිළිවෙල කේතය",
      "workflowTemplateName": "වැඩ පිළිවෙල අච්චු නාමය",
      "version": "සංස්කරණය",
      "lastUpdatedBy": "අවසන් වරට යාවත්කාලීන කළේ",
      "lastUpdatedAt": "අවසන් වරට යාවත්කාලීන කළ වේලාව",
      "viewTemplate": "වැඩ පිළිවෙල අච්චුව බලන්න",
      "editTemplate": "වැඩ පිළිවෙල අච්චුව සංස්කරණය කරන්න",
      "duplicateTemplate": "වැඩ පිළිවෙල අච්චුව පිටපත් කරන්න",
      "deleteTemplate": "වැඩ පිළිවෙල අච්චුව මකන්න",
      "duplicating": "පිටපත් කරමින්…",
      "deleteTitle": "වැඩ පිළිවෙල අච්චුව මකන්න",
      "entityLabel": "වැඩ පිළිවෙල අච්චුව"
    },
    "kpi": {
      "breadcrumb": "KPI වින්‍යාසය",
      "title": "KPI වින්‍යාසය",
      "workflowTemplateName": "වැඩ පිළිවෙල අච්චු නාමය",
      "workflowStage": "වැඩ පිළිවෙල අදියර",
      "kpisTitle": "ප්‍රධාන කාර්ය සාධන දර්ශක (KPI)",
      "timeToComplete": "සම්පූර්ණ කිරීමට ගතවන කාලය (TTC)",
      "timeToRemind": "මතක් කිරීමට කාලය (TTR)",
      "timeToEscalate": "ඉහළ නැංවීමට කාලය (TTE)",
      "days": "දින",
      "hours": "පැය"
    },
    "escalationRules": {
      "breadcrumb": "ඉහළ නැංවීමේ නීති",
      "title": "ඉහළ නැංවීමේ නීති",
      "workflowTemplateName": "වැඩ පිළිවෙල අච්චු නාමය",
      "workflowStage": "වැඩ පිළිවෙල අදියර",
      "hierarchyTitle": "ඉහළ නැංවීමේ ශ්‍රේණිගත කිරීම",
      "reminderRecipient": "මතක් කිරීම ලබන්නා",
      "escalationLevel1": "ඉහළ නැංවීමේ මට්ටම 1 ලබන්නා",
      "escalationLevel2": "ඉහළ නැංවීමේ මට්ටම 2 ලබන්නා",
      "selectUsers": "පරිශීලක(යි) තෝරන්න",
      "selectUserRoles": "පරිශීලක භූමිකා(ය) තෝරන්න",
      "notificationOptions": "දැනුම්දීම් විකල්ප",
      "systemNotification": "පද්ධති දැනුම්දීම",
      "emailNotification": "විද්‍යුත් තැපැල් දැනුම්දීම"
    },
    "designer": {
      "title": "වැඩ පිළිවෙල අච්චු නිර්මාණක",
      "loading": "වැඩ පිළිවෙල අච්චුව පූරණය වෙමින්…",
      "loadFailed": "වැඩ පිළිවෙල අච්චුව පූරණය කළ නොහැක.",
      "back": "ආපසු",
      "saveDraft": "කෙටුම්පත ලෙස සුරකින්න",
      "validating": "සත්‍යාපනය කරමින්…",
      "validateWorkflow": "වැඩ පිළිවෙල සත්‍යාපනය කරන්න",
      "activating": "සක්‍රිය කරමින්…",
      "activateWorkflow": "වැඩ පිළිවෙල සක්‍රිය කරන්න",
      "versionNo": "සංස්කරණ අංකය",
      "status": "තත්ත්වය",
      "statusDraft": "කෙටුම්පත",
      "statusActive": "සක්‍රිය",
      "statusInactive": "අක්‍රිය",
      "letterTemplate": "ලිපි අච්චුව",
      "selectLetterTemplate": "ලිපි අච්චුව තෝරන්න",
      "selectFileCategoryFirst": "පළමුව ගොනු කාණ්ඩය තෝරන්න",
      "selectSubFileCategoryFirst": "පළමුව උප ගොනු කාණ්ඩය තෝරන්න",
      "noSubFileCategoriesAvailable": "උප ගොනු කාණ්ඩ නොමැත",
      "draftVersionCodeNote": "මෙම වැඩ පිළිවෙල අච්චුව සක්‍රිය කරන තෙක්, මෙහි පෙන්වන සංස්කරණ අංකය සහ වැඩ පිළිවෙල කේතය තාවකාලිකව ලබා දෙන ලද ඒවා වනු ඇත.",
      "activeOfficerEditNote": "ඒකාබද්ධීකරණ නිලධාරියා පමණක් වෙනස් කළ හැක.",
      "saveAllocationOfficer": "සුරකින්න",
      "allocationOfficerSaved": "ඒකාබද්ධීකරණ නිලධාරියා සාර්ථකව යාවත්කාලීන කරන ලදී.",
      "allocationOfficerUnchanged": "සුරැකීමට පෙර වෙනස් ඒකාබද්ධීකරණ නිලධාරියෙකු තෝරන්න.",
      "allocationOfficerSaveFailed": "ඒකාබද්ධීකරණ නිලධාරි වෙනස සුරැකීමට නොහැක. කරුණාකර නැවත උත්සාහ කරන්න.",
      "activeConflictWarning": "මෙම ගොනු කාණ්ඩය සහ උප ගොනු කාණ්ඩය සඳහා වැඩ පිළිවෙල අච්චුවක් දැනටමත් ඇත. පවතින සක්‍රිය වැඩ පිළිවෙල අච්චුවක් ප්‍රතිස්ථාපනය කිරීමට උත්සාහ නොකරන බව තහවුරු කර ගන්න.",
      "canvasAriaLabel": "වැඩ පිළිවෙල කැන්වසය",
      "start": "ආරම්භය",
      "end": "අවසානය",
      "addNext": "+ ඊළඟ අදියර එක් කරන්න",
      "removeStage": "අදියර ඉවත් කරන්න",
      "stageBadge": "අදියර {{num}}",
      "newStage": "නව අදියර",
      "defaultStages": {
        "allocationOfficerAssignment": "අනුයෝජනය නිලධාරි පැවරීම",
        "closure": "වැසීම",
        "returnToAllocationOfficer": "අනුයෝජනය නිලධාරිය වෙත ආපසු"
      },
      "stageProperties": "වැඩ පිළිවෙල අදියර ගුණ",
      "selectedStage": "තෝරාගත් අදියර",
      "stageName": "අදියර නාමය",
      "enterStageName": "අදියර නාමය ඇතුළත් කරන්න",
      "stageOption": "අදියර {{num}} - {{label}}",
      "selectStageHint": "ගුණාංග වින්‍යාස කිරීමට කැන්වසය මත අදියරක් තෝරන්න.",
      "viewRoutingRules": "මග හැරීමේ නීති බලන්න",
      "configureRoutingRules": "මග හැරීමේ නීති වින්‍යාස කරන්න",
      "viewKpis": "KPIs බලන්න",
      "configureKpis": "KPIs වින්‍යාස කරන්න",
      "viewEscalationRules": "උසස් කිරීමේ නීති බලන්න",
      "configureEscalationRules": "උසස් කිරීමේ නීති වින්‍යාස කරන්න",
      "viewAssignment": "පවරීම බලන්න",
      "configureAssignment": "පවරීම වින්‍යාස කරන්න",
      "templateUpdates": "වැඩ පිළිවෙල අච්චු යාවත්කාලීන",
      "createdUpdatedAt": "සාදන/යාවත්කාලීන කළ වේලාව",
      "createdUpdatedBy": "සාදන/යාවත්කාලීන කළသူ",
      "cancelWorkflowTitle": "වැඩ පිළිවෙල අච්චුව අවලංගු කරන්න",
      "cancelWorkflowMessage": "අවලංගු කිරීමට අවශ්‍යද? සුරකි නොමැති වෙනස්කම් නැති වේ.",
      "replaceActiveTitle": "සක්‍රිය වැඩ පිළිවෙල අච්චුව ප්‍රතිස්ථාපනය කරන්න",
      "replaceActiveMessage": "මෙම ගොනු කාණ්ඩය සහ උප ගොනු කාණ්ඩය සඳහා වෙනත් සක්‍රිය වැඩ පිළිවෙල අච්චුවක් ඇත. එය අක්‍රිය කර මෙය සක්‍රිය කිරීමට අවශ්‍යද?",
      "routingSaved": "මාර්ගගත කිරීමේ නීති සාර්ථකව සුරකින ලදී.",
      "kpisSaved": "KPIs සාර්ථකව සුරකින ලදී.",
      "escalationSaved": "ඉහළ නැංවීමේ නීති සාර්ථකව සුරකින ලදී.",
      "closureSaved": "අවසන් කිරීමේ පැවරුම සාර්ථකව සුරකින ලදී.",
      "draftSaved": "වැඩ පිළිවෙල අච්චුව කෙටුම්පත ලෙස සාර්ථකව සුරකින ලදී.",
      "activated": "වැඩ පිළිවෙල අච්චුව සාර්ථකව සක්‍රිය කරන ලදී. එය දැන් කාර්ය පවරීම සඳහා ලබා ගත හැක.",
      "validationResultTitle": "වැඩ පිළිවෙල සත්‍යාපන ප්‍රතිඵලය",
      "returnToDesigner": "වැඩ පිළිවෙල අච්චු නිර්මාණක වෙත ආපසු",
      "routing": {
        "title": "මාර්ගගත කිරීමේ නීති වින්‍යාස කරන්න",
        "loading": "මාර්ගගත කිරීමේ නීති පූරණය වෙමින්…",
        "defaultNextStage": "පෙරනිමි ඊළඟ අදියර",
        "allowedRevertStages": "අනුමත ආපසු හැරවීමේ අදියර",
        "selectStages": "අදියර(ය) තෝරන්න",
        "cancelTitle": "මග හැරීමේ වින්‍යාසය අවලංගු කරන්න",
        "cancelMessage": "මග හැරීමේ නීති වින්‍යාස කිරීම අවලංගු කිරීමට අවශ්‍යද?"
      },
      "kpiModal": {
        "title": "KPIs වින්‍යාස කරන්න",
        "cancelTitle": "KPI වින්‍යාසය අවලංගු කරන්න",
        "cancelMessage": "KPIs වින්‍යාස කිරීම අවලංගු කිරීමට අවශ්‍යද?",
        "ttcPlaceholder": "උදා. 14",
        "ttrPlaceholder": "උදා. 12",
        "ttePlaceholder": "උදා. 16"
      },
      "escalation": {
        "title": "ඉහළ නැංවීමේ නීති වින්‍යාස කරන්න",
        "cancelTitle": "උසස් කිරීමේ වින්‍යාසය අවලංගු කරන්න",
        "cancelMessage": "උසස් කිරීමේ නීති වින්‍යාස කිරීම අවලංගු කිරීමට අවශ්‍යද?"
      },
      "assignment": {
        "title": "පවරීම වින්‍යාස කරන්න",
        "cancelTitle": "පවරීමේ වින්‍යාසය අවලංගු කරන්න",
        "cancelMessage": "පවරීම වින්‍යාස කිරීම අවලංගු කිරීමට අවශ්‍යද?",
        "selectUserRole": "පරිශීලක භූමිකාව තෝරන්න",
        "assignedUser": "පවරන ලද පරිශීලක"
      },
      "errors": {
        "templateNameRequired": "වැඩ පිළිවෙල අච්චු නාමය අවශ්‍යය.",
        "fileCategoryRequired": "ගොනු කාණ්ඩය අවශ්‍යය.",
        "subFileCategoryRequired": "උප ගොනු කාණ්ඩය අවශ්‍යය.",
        "allocationOfficerRequired": "වෙන් කිරීමේ නිලධාරියා අවශ්‍යය."
      }
    }
  },
  "audit": {
    "justNow": "මේ දැන්",
    "minutesAgo": "මිනිත්තු {{count}}කට පෙර",
    "minutesAgo_plural": "මිනිත්තු {{count}}කට පෙර",
    "hoursAgo": "පැය {{count}}කට පෙර",
    "hoursAgo_plural": "පැය {{count}}කට පෙර",
    "yesterday": "ඊයේ",
    "daysAgo": "දින {{count}}කට පෙර",
    "breadcrumb": "විගණන සටහන්",
    "title": "විගණන සටහන්",
    "generating": "ජනනය වෙමින්…",
    "exportPdf": "PDF ලෙස අපනයනය",
    "exportCsv": "CSV ලෙස අපනයනය",
    "filters": "පෙරහන්",
    "activityFrom": "ක්‍රියාකාරකම සිට",
    "activityTypes": "ක්‍රියාකාරකම් වර්ග",
    "selectActivityTypes": "ක්‍රියාකාරකම් වර්ග තෝරන්න",
    "activityPerformedBy": "ක්‍රියාකාරකම සිදුකළේ",
    "selectActorNames": "නම(ය) තෝරන්න",
    "noLogsFound": "විගණන සටහන් කිසිවක් හමු නොවීය.",
    "activityType": "ක්‍රියාකාරකම් වර්ගය",
    "summary": "සාරාංශය",
    "targetEntity": "ඉලක්ක ආයතනය",
    "target": "ඉලක්කය",
    "showingRange": "විගණන සටහන් {{total}} න් {{start}} සිට {{end}} දක්වා පෙන්වයි"
  },
  "notFound": {
    "title": "පිටුව හමු නොවීය",
    "subtitle": "ලිපිනය වැරදි විය හැක හෝ පිටුව ඉවත් කර ඇත.",
    "goToTasks": "කාර්ය සහ නඩු වෙත යන්න"
  },
  "review": {
    "breadcrumb": "නඩු ඉල්ලීමක් සාදන්න",
    "pageTitle": "නඩු ඉල්ලීම් විස්තර සමාලෝචනය",
    "confirmHint": "AGD වෙත මෙම ඉල්ලීම ඉදිරිපත් කිරීමට පෙර කරුණාකර තහවුරු කරන්න.",
    "step": "පියවර {{num}}",
    "caseOverview": "නඩු දළ විශ්ලේෂණය",
    "caseCategorization": "නඩු වර්ගීකරණය",
    "caseDetails": "නඩු විස්තර",
    "caseIntakeDetails": "නඩු භාරගැනීමේ විස්තර",
    "partyDetails": "පාර්ශ්ව විස්තර",
    "partiesInvolved": "සම්බන්ධ පාර්ශ්ව",
    "petitionerDetails": "පෙත්සම්කරු විස්තර",
    "respondentDetails": "වගඋත්තරකරු විස්තර",
    "requesterDetails": "ඉල්ලුම්කරු විස්තර",
    "informationRequestDetails": "තොරතුරු ඉල්ලීම් විස්තර",
    "additionalInformation": "අතිරේක තොරතුරු",
    "incidentDetails": "සිද්ධි විස්තර",
    "incidentMatterDetails": "සිද්ධිය / කරුණු විස්තර",
    "timeline": "කාලරේඛාව",
    "submission": "ඉදිරිපත් කිරීම",
    "submissionPhysicalDelivery": "ඉදිරිපත් කිරීම සහ භෞතික ගොනු බෙදාහැරීම",
    "requestSubmittersDetails": "ඉල්ලීම ඉදිරිපත් කරන්නාගේ විස්තර",
    "physicalFileDeliveryMethod": "භෞතික ගොනු බෙදාහැරීමේ ක්‍රමය",
    "uploadDocuments": "ලේඛන උඩුගත කරන්න",
    "victimDetails": "පීඩිත විස්තර",
    "offenceAccusedDetails": "වරද සහ චෝදනාකරු විස්තර",
    "accusedPersonDetails": "චෝදනාකරු විස්තර",
    "accusedPersonExtraditionMla": "චෝදනාකරු විස්තර - ප්‍රත්‍යර්පණය සහ MLA",
    "legalExtradition": "නීති සහ ප්‍රත්‍යර්පණය",
    "legalExtraditionCaseDetails": "නීති සහ ප්‍රත්‍යර්පණ නඩු විස්තර",
    "rightToInformation": "තොරතුරු දැනගැනීමේ අයිතිය",
    "categorization": "වර්ගීකරණය"
  }
}